//Constants

import { get } from '../../services/Network'
import Api from "../../services/Api";
import { call, put, all, select } from 'redux-saga/effects'
import moment from 'moment'
import toast from 'react-hot-toast'
import { serverValidationMessage } from './dataEntryComponents/serverValidationError'
import {
    isSuccessStatusCode,
    API_INITIAL,
    API_FETCHING,
    API_SUCCESS,
    API_FAILURE,
    ReduxApiStatus
} from "../../common/constants/ApiConstants";
import {
    getRequestTypes,
    getDisclosingInstituionAPI,
    getTransactionAttributesAPI,
    getRequestorDetailsAPI,
    getContactDetailsAPI,
    getFeeSchedulesAPI,
    getTransactionNotesAPI,
    getAdditionalChargeTypeAPI,
    getAdditionalChargeRecordsAPI,
    updateBillToContactDetailsAPI,
    getRequestorSearchDetailsAPI,
    getTransactionDocumentsAPI,
    getRejectOptionsAPI,
    getShippingServicesAPI,
    getReleaseMethodOptionsAPI,
    patchPatientsNotesAPI,
    patchRequestorNotesAPI,
    patchSendToRequestorContact,
    uploadDocumentAPI,
    uploadBlobDocumentAPI,
    postCancellationReasonsAPI,
    getRequestorBillingDetailsAPI,
    getRequestorBillingDetailsByTxAPI,
    getTransactionNoteTypesAPI,
    updateTransactionNotesAPI,
    updateAdditionalChargesAPI,
    putSendToRequestorContactAPI,
    rejectionContactOverrideAPI,
    getDocumentByIdAPI,
    updateDocumentAPI,
    batchUpdateDocumentsAPI,
    getDocumentSourcesAPI,
    getRejectionLetterDataAPI,
    getPreviousTransactionAPI,
    deleteDocumentByIdAPI,
    updateBillingPaneFieldsAPI,
    retrieveProtocolAPI,
    getCancellationReasonsAPI,
    getPatientSearchDetailsAPI,
    getSelectedPHICodesAPI,
    getPHICodesAPI,
    createPatientRecordAPI,
    updatePHIdisclosedAPI,
    postRejectionActionAPI,
    getUserGroupsAPI,
    generateNextTransactionIdAPI,
    createUserTaskCommentAPI,
    getDisclosureReasonAPI,
    updateDisclosureInformationAPI,
    getUserTasksAPI,
    getUserTaskCommentsAPI,
    adNewUserTaskAPI,
    updateUserTaskAPI,
    deleteTransactionTaskAPI,
    saveInformationToReleaseAPI,
    completeTransactionAPI,
    patchDetailsCompleteAPI,
    patchRequestorCompleteAPI,
    patchBillingCompleteAPI,
    patchPatientDetailsAPI,
    getAuditTypesAPI,
    getOBOsAPI,
    getValidateAPI,
    getAuditTrailAPI,
    getDuplicatesAPI,
    patchTransactionOnFileAPI,
    postWebPrintScanAPI,
    getTransactionDocumentsOnFileAPI,
    readDocumentDDSBarcodeAPI,
    getFacilitiesAdditionalFieldsAPI,
    getWaitAndHoldReasonsAPI,
    postWaitAndHoldReasonsAPI,
    patchTransactionContinueAPI,
    putAuditDigitalFaxValidationAPI,
    putAuditTransactionSensitiveInfoAPI,
    getStatusIndicatorAPI,
    putUserViewDocumentAPI,
    returnToQueueAPI,
    getAssessmentResultsAPI,
    getQAErrorsAPI,
    getQAIssuesAPI,
    getQAPDIssuesAPI,
    postQATransactionIssueAPI,
    resolveIssueAPI,
    removeIssueAPI,
    getAIFeedbackAPI,
    submitAIFeedbackAPI,
    deleteAIFeedbackAPI,
    submitAIFeedbackBulkAPI,
    undoAIFeedbackBulkAPI,
    getReviewEntitiesAPI,
    getAISensitivityTypesAPI,
    createAIReviewEntityAPI,
    getAuditUsersAPI,
    uploadUpdateBlobDocumentAPI,
    uploadUpdateDocumentAPI,
    getCertificationTypesAPI,
    setCertificationTemplateAPI,
    disputeIssueAPI,
    upholdIssueAPI,
    getCompleteStatusCheckAPI,
    getFeeSchedulesCheckAPI,
    updateInformationToReleaseApi,
    createSendToContactApi,
    updateSendToContactApi,
    LockTransactionAPI,
    getFacilityConfigurationAPI,
} from './test/DataEntry.APIs';
import {
    generateContactSearchReponseObject,
    generatePickerOptions,
    generatePickerOptionsUndefinedDefault,
    generateRejectLetterResponseObject,
    generatePickerOptionsNoDefault,
    generateSearchResponseObject
} from '../../common/utils/appUtils';
import {
    generatePickerOptionsNew,
    updateUserTaskDetailsHelperFunction,
    updateUserTaskCommentsHelperFunction,
    sortDateObject,
    getSortedTasks
} from '../../common/utils/reduxUtils';

import { normalizeData } from '../../common/utils/appUtils';
import { push, goBack } from '../../redux/navigation/navigationDucks';
import { LandingPageActionConstants, clearUserLocksSaga, refreshSelectedFacilityCountsSaga } from '../landingPage/LandingPageDucks';
import Rejection from '../../models/rejection';
import TransactionDocument, {
    documentFromApiResponse,
    DocumentUpdateRequests,
    DocumentUploadRequest
} from '../../models/document';
import { NewContactResponse, NewSendToContact, Requestor, SendToContactUpdate } from '../../models/requestor';
import { ReleaseInfoUpdate, TransactionDetails, SensitiveInfoUpdateAPI, OTHER_DOCUMENTS_RELEASE_ID } from '../../models/transaction';
import { AxiosResponse } from 'axios';
import { Address, Contact, NameIdPair } from '../../models/misc';
import { AssessmentResult, EntityType, ReviewEntity } from '../../models/assessment';
import { DocTypes } from '../../common/constants/DocTypes';
import { SensitiveInfo } from '../../models/transaction';
import FacilityConfiguration from '../../models/facilityConfiguration';
import { IntakeFromApiResponse, RequestAnalysis, RequestAnalysisData, FieldGrounding } from "../../models/intake";
import {
    getIntakeIntelligenceActionCreator,
    requestIntakeIntelligenceActionCreator,
    setFeedbackForIntakeFieldActionCreator,
    getIntakeIntelligenceSaga,
    requestIntakeIntelligenceSaga,
    setFeedbackForIntakeFieldSaga,
    intakeDucksReducer,
    IntakeFeedback,
} from "./IntakeDucks";
import { autoExtractOnRequestUpload } from "./intakeAutoTrigger";
import { isQuickEntryEligibleFromInputs } from "./quickEntryEligibility";
import { RequestType } from "../../models/requestType";
import TransactionIssue, { QaError } from "../../models/transactionIssue";
import FeeSchedule from "../../models/feeSchedule";
import { AnyAction } from "redux";

// Re-exported for backward compatibility with any existing import site not
// covered by AC17's 3 named external files + services/sagas/index.js (Spec
// #34098 / F1a, tidy-first #5) - the symbols themselves now live in
// IntakeDucks.ts.
export {
    getIntakeIntelligenceActionCreator,
    requestIntakeIntelligenceActionCreator,
    setFeedbackForIntakeFieldActionCreator,
    getIntakeIntelligenceSaga,
    requestIntakeIntelligenceSaga,
    setFeedbackForIntakeFieldSaga,
};
export type { IntakeFeedback };

export const DataEntryActionConstants = {
    onChangeTab: "onChangeTab/DataEntryConstants",
    GET_ASSESSMENT_RESULTS: "GET_ASSESSMENT_RESULTS",
    GET_ASSESSMENT_RESULTS_SUCCESS: "GET_ASSESSMENT_RESULTS_SUCCESS",
    GET_ASSESSMENT_RESULTS_FAILURE: "GET_ASSESSMENT_RESULTS_FAILURE",
    GET_REVIEW_ENTITIES: "GET_REVIEW_ENTITIES",
    GET_REVIEW_ENTITIES_SUCCESS: "GET_REVIEW_ENTITIES_SUCCESS",
    GET_REVIEW_ENTITIES_FAILURE: "GET_REVIEW_ENTITIES_FAILURE",
    getRequestTypesAndPurposesRequest: "getRequestTypesAndPurposesRequest/DataEntryDetails",
    getRequestTypesAndPurposesSuccess: "getRequestTypesAndPurposesSuccess/DataEntryDetails",
    getRequestTypesAndPurposesFailure: "getRequestTypesAndPurposesFailure/DataEntryActionConstants",
    GET_TRANSACTIONS_ATTRIBUTES: 'GET_TRANSACTIONS_ATTRIBUTES',
    GET_TRANSACTIONS_ATTRIBUTES_SAGA: 'GET_TRANSACTIONS_ATTRIBUTES_SAGA',
    GET_FEE_SCHEDULE_DATA: 'GET_FEE_SCHEDULE_DATA',
    ASSIGN_TRANSACTION_ID: 'ASSIGN_TRANSACTION_ID',
    GET_TRANSACTIONS_PATIENT_ATTRIBUTES: 'GET_TRANSACTIONS_PATIENT_ATTRIBUTES',
    getTransactionDetailsSuccess: "getTransactionDetailsSuccess/DataEntryDetails",
    getDefaultFeeSchedule: "getDefaultFeeSchedule",
    getFacilityDiscloseInstitutionsSuccess: "getFacilityDiscloseInstitutionSuccess/DataEntryDetails",
    getFacilityDiscloseInstitutionsFailure: "getFacilityDiscloseInstitutionsFailure/DataEntryDetails",
    getFeeScheduleFailure: "getFeeScheduleFailure/DataEntryDetails",
    getFacilityDiscloseInstitutionsRequest: "getFacilityDiscloseInstitutionsRequest/DataEntryDetails",
    GET_DOCUMENT_BY_ID_SAGA: 'GET_DOCUMENT_BY_ID_SAGA',
    getRequestorDetailsSuccess: "getRequestorDetailsSuccess/DataEntryDetails",
    getContactDetailsSuccess: "getContactDetailsSuccess/DataEntryDetails",
    updatePatientDetails: "updatePatientDetails/DataEntryDetails",
    /**
     * @deprecated
     */
    updateRequestorDetails: "updateRequestorDetails/DataEntryDetails",
    /**
     * Sets the send-to requestor in the state without making any API call.
     */
    setRequestorDetails: "setRequestorDetails",
    /**
     * Sets the send-to contact in the state without making any API call.
     */
    setRequestorContact: "setRequestorContact",
    /**
     * Makes an API call to update the send-to contact.
     */
    updateSendToContact: "updateSendToContact",
    /**
     * @deprecated very type-unsafe
     */
    updateTransactionDetails: "updateTransactionDetails/DataEntryDetails",
    GET_FEE_SCHEDULE_SUCCESS: "GET_fEE_SCHEDULE_SUCCESS/DATAENTRYDETAILS",
    getTransactionNotesRequest: "getTransactionNotesRequest/DataEntryDetails",
    getTransactionNotesSuccess: "getTransactionNotesSuccess/DataEntryDetails",
    getTransactionNotesFailure: "getTransactionNotesFailure/DataEntryDetails",
    getAdditionalChargeType: "getAdditionalChargeType",
    getAdditionalChargeTypeSuccess: "GET_ADDITIONAL_CHARGE_TYPE_SUCCESS",
    getAdditionalChargeTypeFailure: "getAdditionalChargeTypeFailure/DataEntryDetails",
    getAdditionalChargeRecords: "getAdditionalChargeRecords",
    getAdditionalChargeRecordsSuccess: "GET_ADDITIONAL_CHARGE_RECORDS_SUCCESS",
    getAdditionalChargeRecordsFailure: "GET_ADDITIONAL_CHARGE_RECORDS_FAILURE",
    /**
     * @deprecated replaced by createSendToContact
     */
    SEND_TO_REQUESTOR_CONTACT_DATA_SAGA: 'SEND_TO_REQUESTOR_CONTACT_DATA_SAGA',
    UPDATE_SEND_TO_REQUESTOR_DATA_SAGA: 'UPDATE_SEND_TO_REQUESTOR_DATA_SAGA',
    createSendToContact: "createSendToContact",
    /**
     * Sets release method in the state without making any API call.
     */
    setReleaseMethod: "setReleaseMethod",
    updateBillToRequestorRequest: "updateBillToRequestorRequest/DataEntryDetails",
    updateBillToRequestorSuccess: "updateBillToRequestorSuccess/DataEntryDetails",
    updateBillToRequestorFailure: "updateBillToRequestorFailure/DataEntryDetails",
    updateDeliveryInstructionsStatus: "updateDeliveryInstructionsStatus",
    getRequestorSearchDetailsSuccess: "getRequestorSearchDetailsSuccess/DataEntryDetails",
    getRequestorSearchDetailsFailure: "getRequestorSearchDetailsFailure/DataEntryDetails",
    getRequestorSearchDetailsSAGA: "getRequestorSearchDetailsSAGA/DataEntryDetails",
    getRejectOptionsRequest: "getRejectOptionsRequest/DataEntryDetails",
    getRejectOptionsSuccess: "getRejectOptionsSuccess/DataEntryDetails",
    getRejectOptionsFailure: "getRejectOptionsFailure/DataEntryDetails",
    getContactSeacrhDetailsReset: "getContactSeacrhDetailsReset/DataEntryDetails",
    getContactSeacrhDetailsSuccess: "getContactSeacrhDetailsSuccess/DataEntryDetails",
    getContactSearchDetailsFailure: "getContactSearchDetailsFailure/DataEntryDetails",
    getContactSearchDetailsSAGA: "getContactSearchDetailsSAGA/DataEntryDetails",
    getTransactionDocumentsRequest: "getTransactionDocumentsRequest/DataEntryDetails",
    getTransactionDocumentsSuccess: "getTransactionDocumentsSuccess/DataEntryDetails",
    getTransactionDocumentsFailure: "getTransactionDocumentsFailure/DataEntryDetails",
    GET_SHIPPING_SERVICE_DATA: "getShippingServicesData",
    getShippingServicesSuccess: "GET_SHIPPING_SERVICES_SUCCESS",
    getShippingServicesFailure: "GET_SHIPPING_SERVICES_FAILURE",
    getReleaseMethodOptionsData: 'GET_RELEASE_METHOD_OPTIONS_DATA',
    getReleaseMethodOptionsSuccess: "GET_RELEASE_METHOD_OPTIONS_SUCCESS",
    getReleaseMethodOptionsFailure: "GET_RELEASE_METHOD_OPTIONS_FAILURE",
    patchPatientsNotesSagas: "patchPatientsNotesSagas/DataEntryDetails",
    patchRequestorsNotesSagas: "patchRequestorsNotesSagas/DataEntryDetails",
    patchSendToRequestorContactSagas: "patchSendToRequestorContactSagas/DataEntryDetails",
    uploadDocumentRequest: "uploadDocumentRequest/DataEntryDetails",
    uploadDocumentSuccess: "uploadDocumentSuccess/DataEntryDetails",
    uploadDocumentFailure: "uploadDocumentFailure/DataEntryDetails",
    uploadDocumentInitial: "uploadDocumentInitial/DataEntryDetails",
    getRequestorBillingDetailsSuccess: "GET_REQUESTOR_BILLING_DETAILS_SUCCESS",
    getTransactionNoteTypesRequest: "getTransactionNoteTypesRequest/DataEntryDetails",
    getTransactionNoteTypesSuccess: "getTransactionNoteTypesSuccess/DataEntryDetails",
    updateTransactionNotes: "updateTransactionNotes/DataEntryDetails",
    UPDATE_ADDITIONAL_CHARGES: 'UPDATE_ADDITIONAL_CHARGES',
    UPDATE_ADDITIONAL_CHARGES_SAGA: 'UPDATE_ADDITIONAL_CHARGES_SAGA',
    uploadMultipleDocumentsRequest: "uploadMultipleDocumentsRequest/DataEntryDetails",
    rejectionContactOverrideRequest: "rejectionContactOverrideRequest/DataEntryDetails",
    getDocumentByIdSuccess: "getDocumentByIdSuccess",
    getDocumentByIdFailure: "getDocumentByIdFailure",
    resetState: "resetState/DataEntryDetails",
    updateDocumentRequest: "updateDocumentRequest/DataEntryDetails",
    getDocumentSourcesRequest: "getDocumentSourcesRequest/DataEntryDetails",
    getDocumentSourcesSuccess: "getDocumentSourcesSuccess/DataEntryDetails",
    batchUpdateDocumentsRequest: "batchUpdateDocumentsRequest/DataEntryDetails",
    batchUpdateDocumentsSuccess: "batchUpdateDocumentsSuccess/DataEntryDetails",
    getRejectionLetterDataAPISuccess: "getRejectionLetterDataAPISuccess/DataEntryDetails",
    getRejectionLetterDataAPIInitial: "getRejectionLetterDataAPIInitial/DataEntryDetails",
    getRejectionLetterSagas: "getRejectionLetterSagas/DataEntryDetails",
    getPreviousTransactionAPISuccess: "getPreviousTransactionAPISuccess/DataEntryDetails",
    getPreviousTransactionAPIFailure: "getPreviousTransactionAPIFailure/DataEntryDetails",
    getPreviousTransactionSagas: "getPreviousTransactionSagas/DataEntryDetails",
    deleteDocument: 'deleteDocumentById',
    deleteDocumentAPIInitial: 'deleteDocumentAPIInitial/DataEntryDetails',
    deleteDocumentAPISuccess: 'deleteDocumentAPISuccess/DataEntryDetails',
    deleteDocumentAPIFailure: 'deleteDocumentAPIFailure/DataEntryDetails',
    updateBillingPaneFields: "updateBillingPaneFields/DataEntryDetails",
    GET_NEXT_TRANSACTION_REQUEST: "GET_NEXT_TRANSACTION_REQUEST",
    GET_NEXT_TRANSACTION_REQUEST_SAGA: "GET_NEXT_TRANSACTION_REQUEST_SAGA",
    SET_NEXT_TRANSACTION_NULL: "SET_NEXT_TRANSACTION_NULL",
    SET_LAST_USED_REQUESTOR: "SET_LAST_USED_REQUESTOR",
    getRetrieveProtocolRequest: "getRetrieveProtocolRequest/DataEntryDetails",
    GET_SELECTED_PHI_CODES_SAGA: "getSelectedPHICodesSaga/DataEntryDetails",
    getSelectedPHICodesSuccess: "getSelectedPHICodesAPISuccess",
    getSelectedPHICodesFailure: "getSelectedPHICodesAPIFailure",
    getRetrieveProtocolSuccess: "getRetrieveProtocolSuccess/DataEntryDetails",
    getRetrieveProtocolFailure: "getRetrieveProtocolFailure/DataEntryDetails",
    getCancellationReasons: "GET_CANCELLATION_REASONS_SAGA",
    getCancellationReasonsSuccess: "getCancellationReasonsSuccess",
    getCancellationReasonsFailure: "getCancellationReasonsFailure",
    postCancellationReasonsSuccess: "postCancellationReasonsSuccess/DataEntryDetails",
    postCancellationReasonsRequest: "postCancellationReasonsRequest/DataEntryDetails",
    GET_PATIENT_SEARCH_DETAILS: "GET_PATIENT_SEARCH_DETAILS",
    GET_PATIENT_SEARCH_DETAILS_FAILURE: "GET_PATIENT_SEARCH_DETAILS_FAILURE",
    GET_PATIENT_SEARCH_DETAILS_SAGA: "GET_PATIENT_SEARCH_DETAILS_SAGA",
    getPHICodesRequest: "getPHICoesRequest/DataEntryDetails",
    getPHICodesSuccess: "getPHICodesSuccess/DaetaEntryDetails",
    createPatientRecordRequest: "createPatientRecordRequest/DataEntryDetails",
    createPatientRecordSuccess: "createPatientRecordSuccess/DataEntryDetails",
    UPDATE_PHI_DISCLOSED_SAGA: "UPDATE_PHI_DISCLOSED_SAGA",
    UPDATE_PHI_DISCLOSED_SUCCESS: "UPDATE_PHI_DISCLOSED_SUCCESS",
    UPDATE_PHI_DISCLOSED_FAILURE: "UPDATE_PHI_DISCLOSED_FAILURE",
    POST_REJECTION_ACTION: "POST_REJECTION_ACTION",
    POST_REJECTION_ACTION_FAILURE: "POST_REJECTION_ACTION_FAILURE",
    POST_REJECTION_ACTION_SAGA: "POST_REJECTION_ACTION_SAGA",
    getUserGroupsRequest: "getUserGroupsRequest/DataEntryDetails",
    getUserGroupsSuccess: "getUserGroupsSuccess/DataEntryDetails",
    getUserGroupsFailure: "getUserGroupsFailure/DataEntryDetails",
    GET_DISCLOSURE_REASON: "GET_DISCLOSURE_REASON",
    GET_DISCLOSURE_REASON_SAGA: 'GET_DISCLOSURE_REASON_SAGA',
    updateFormSyncErrors: "updateFormSyncErrors/DataEntryDetails",
    UPDATE_DISCLOSURE_INFORMATION: 'UPDATE_DISCLOSURE_INFORMATION',
    UPDATE_DISCLOSURE_INFORMATION_SAGA: 'UPDATE_DISCLOSURE_INFORMATION_SAGA',
    getUserTasksRequest: "getUserTasksRequest/DataEntryDetails",
    getUserTasksSuccess: "getUserTasksSuccess/DataEntryDetails",
    getUserTasksFailure: "getUserTassksFailure/DataEntryDetails",
    updateUserTasksList: "updateUserTasksList/DataEntryDetails",
    updateUserTaskComments: "updateUserTaskComments/DataEntryDetails",
    createUserTaskComment: "createUserTaskComment/DataEntryDetails",
    addNewUserTaskRequest: "addNewUserTaskRequest/DataEntryDetails",
    updateUserTask: "updateUserTask/DataEntryDetails",
    DELETE_TRANSACTION_TASK: "DELETE_TRANSACTION_TASK",
    DELETE_TRANSACTION_TASK_SAGA: "DELETE_TRANSACTION_TASK_SAGA",
    API_ERROR_STATE: "API_ERROR_STATE",
    HIDE_API_ERROR_MESSAGE: "HIDE_API_ERROR_MESSAGE",
    POPUP_ERROR_STATE: "POPUP_ERROR_STATE",
    HIDE_POPUP_ERROR_MESSAGE: "HIDE_POPUP_ERROR_MESSAGE",
    saveInformationToReleaseRequest: "saveInformationToRelease/DataEntryDetails",
    saveInformationToReleaseResponse: "saveInformationToReleaseResponse/DataEntryDetails",
    updateInformationToReleaseRequest: "updateInformationToReleaseRequest",
    saveInformationToRelease: "saveInformationToRelease",
    saveSensitiveInfoRequest: "saveSensitiveInfo/DataEntryDetails",
    saveSensitiveInfoResponse: "saveSensitiveInfoResponse/DataEntryDetails",
    saveAndUpdateSensitiveInfoRequest: "saveAndUpdateSensitiveInfoRequest",
    saveSensitiveInfo: "saveSensitiveInfo",
    COMPLETE_TRANSACTION_REQUEST: "COMPLETE_TRANSACTION_REQUEST",
    COMPLETE_TRANSACTION_REQUEST_SAGA: "COMPLETE_TRANSACTION_REQUEST_SAGA",
    RETURN_TO_QUEUE_SAGA: "RETURN_TO_QUEUE_SAGA",
    getRequestorBillingDetails: "GET BILL_TO_REQUESTOR_DETAILS",
    getRequestorBillingDetailsFailure: "getRequestorBillingDetailsFailure",
    DETAILS_COMPLETE_SAGA: "DETAILS_COMPLETE_SAGA",
    REQUESTOR_COMPLETE_SAGA: "REQUESTOR_COMPLETE_SAGA",
    BILLING_COMPLETE_SAGA: "BILLING_COMPLETE_SAGA",
    patchPatientDetails: "patchPatientDetails/DataEntryDetails",
    getAuditTypesRequest: "getAuditTypesRequest/DataEntryDetails",
    getAuditTypesSuccess: "getAuditTypesSuccess/DataEntryDetails",
    getAuditTypesFailure: "getAuditTypesFailure/DataEntryActionConstants",
    getOBOsRequest: "getOBOsRequest/DataEntryDetails",
    getOBOsSuccess: "getOBOsSuccess/DataEntryDetails",
    getOBOsFailure: "getOBOsFailure/DataEntryActionConstants",
    getValidateRequest: "GET_VALIDATE_REQUEST",
    getValidateSuccess: "GET_VALIDATE_SUCCESS",
    getValidateFailure: "GET_VALIDATE_FAILURE",
    requestorVerificationEmailSent: "isRequestorVerificationEmailSent/DataEntryDetails",
    requestorVerificationEmailSentReset: "isRequestorVerificationEmailSentReset/DataEntryDetails",
    getAuditTrailRequest: "GET_AUDIT_TRAIL_REQUEST",
    getAuditTrailResponse: "GET_AUDIT_TRAIL_RESPONSE",
    getStatusIndicatorRequest: "GET_STATUS_INDICATOR_REQUEST",
    getStatusIndicatorResponse: "GET_STATUS_INDICATOR_RESPONSE",
    GET_DUPLICATE_TRANSACTIONS: "GET_DUPLICATE_TRANSACTIONS",
    SHOW_DUPLICATE_TRANSACTIONS: "SHOW_DUPLICATE_TRANSACTIONS",
    HIDE_DUPLICATE_TRANSACTIONS: "HIDE_DUPLICATE_TRANSACTIONS",
    getTransactionDocumentsToCopySuccess: "getTransactionDocumentsToCopySuccess/DataEntryDetails",
    getTransactionDocumentsToCopyRequest: "getTransactionDocumentsToCopyRequest/DataEntryDetails",
    resetTransactionDocumentsToCopyRequest: "resetTransactionDocumentsToCopyRequest/DataEntryDetails",
    updateTransactionOnFileRequest: "updateTransactionOnFileRequest/DataEntryDetails",
    patchTransactionOnFileSaga: "patchTransactionOnFileSaga/DataEntryDetails",
    patchTransactionOnFileSuccess: "patchTransactionOnFileSuccess/DataEntryDetails",
    patchTransactionOnFileFailure: "patchTransactionOnFileFailure/DataEntryDetails",
    postWPSRequest: "GET_WPS_REQUEST",
    postWPSResponse: "GET_WPS_RESPONSE",
    clearPreviousTransactionOnComplete: "CLEAR_PREVIOUS_TRANSACTION_ON_COMPLETE",
    readBarCodeDDSRequest: "readBarCodeDDSRequest/DataEntryDetails",
    readBarCodeDDSSuccess: "readBarCodeDDSSuccess/DataEntryDetails",
    readBarCodeDDSFailure: "readBarCodeDDSFailure/DataEntryActionConstants",
    initialTxCountIncrement: "initialTxCountIncrement/DataEntryDetails",
    getFacilityAdditionalFieldsSuccess: "getFacilityAdditionalFieldsSuccess/DataEntryDetails",
    getFacilityAdditionalFieldsFailure: "getFacilityAdditionalFieldsFailure/DataEntryDetails",
    getFacilityAdditionalFieldsRequest: "getFacilityAdditionalFieldsRequest/DataEntryDetails",
    getWaitAndHoldReasonsSuccess: "getWaitAndHoldReasonsSuccess",
    getWaitAndHoldReasonsFailure: "getWaitAndHoldReasonsFailure",
    getWaitAndHoldReasons: "GET_WAIT_HOLD_REASONS_SAGA",
    postWaitAndHoldReasonsRequest: "postWaitAndHoldReasonsRequest/DataEntryDetails",
    postWaitAndHoldReasonsSuccess: "postWaitAndHoldReasonsSuccess/DataEntryDetails",
    patchTransactionContinueRequest: "patchTransactionContinueRequest/DataEntryDetails",
    patchTransactionContinueSuccess: "patchTransactionContinueSuccess/DataEntryDetails",
    updateClinicIDResponse: "updateClinicIDResponse",
    /**
     * @deprecated
     */
    userInputUpdateDataEntryDetailRequestorContact: "userInputUpdateRequestorContact/DataEntryDetails",
    putDigitalFaxValidationSuccess: "putDigitalFaxValidationSuccess/DataEntryDetails",
    putDigitalFaxValidationRequest: "putDigitalFaxValidationRequest/DataEntryDetails",
    putAuditTransactionSensitiveInfoSuccess: "putAuditTransactionSensitiveInfoSuccess/DataEntryDetails",
    putAuditTransactionSensitiveInfoRequest: "putAuditTransactionSensitiveInfoRequest/DataEntryDetails",
    userViewedDocumentRequest: "audit/userViewedDocument/Request",
    userViewedDocumentSucess: "audit/userViewedDocument/Sucess",
    userViewedDocumentFailure: "audit/userViewedDocument/Failure",
    setConfirmFax: "save/ComfirmFaxNumber",
    GET_QA_ERRORS_RESULTS: "GET_QA_ERRORS_RESULTS",
    GET_QA_ERRORS_RESULTS_SUCCESS: "GET_QA_ERRORS_RESULTS_SUCCESS",
    GET_QA_ERRORS_RESULTS_FAILURE: "GET_QA_ERRORS_RESULTS_FAILURE",
    GET_QA_ISSUES_RESULTS: "GET_QA_ISSUES_RESULTS",
    GET_QA_ISSUES_RESULTS_SUCCESS: "GET_QA_ISSUES_SUCCESS",
    GET_QA_ISSUES_RESULTS_FAILURE: "GET_QA_ISSUES_FAILURE",
    GET_QA_PD_ISSUES_RESULTS: "GET_QA_PD_ISSUES_RESULTS",
    GET_QA_PD_ISSUES_RESULTS_SUCCESS: "GET_QA_PD_ISSUES_SUCCESS",
    GET_QA_PD_ISSUES_RESULTS_FAILURE: "GET_QA_PD_ISSUES_FAILURE",
    GET_SENSITIVITY_TYPES_RESULTS: "GET_SENSITIVITY_TYPES_RESULTS",
    GET_SENSITIVITY_TYPES_RESULTS_SUCCESS: "GET_SENSITIVITY_TYPES_RESULTS_SUCCESS",
    GET_SENSITIVITY_TYPES_RESULTS_FAILURE: "GET_SENSITIVITY_TYPES_RESULTS_FAILURE",
    postQATransactionIssueSuccess: "POST_QA_TRANSACTION_ISSUE_SUCCESS",
    postQATransactionIssueFailure: "POST_QA_TRANSACTION_ISSUE_FAILURE",
    postQATransactionIssueRequest: "POST_QA_TRANSACTION_ISSUE_REQUEST",
    resolveQATransactionIssueSuccess: "RESOLVE_QA_TRANSACTION_ISSUE_SUCCESS",
    resolveQATransactionIssueFailure: "RESOLVE_QA_TRANSACTION_ISSUE_FAILURE",
    resolveQATransactionIssueRequest: "RESOLVE_QA_TRANSACTION_ISSUE_REQUEST",
    removeQATransactionIssueSuccess: "REMOVE_QA_TRANSACTION_ISSUE_SUCCESS",
    removeQATransactionIssueFailure: "REMOVE_QA_TRANSACTION_ISSUE_FAILURE",
    removeQATransactionIssueRequest: "REMOVE_QA_TRANSACTION_ISSUE_REQUEST",
    disputeIssueRequest: "disputeIssueRequest",
    disputeIssueSuccess: "disputeIssueSuccess",
    disputeIssueFailure: "disputeIssueFailure",
    upholdIssueRequest: "upholdIssueRequest",
    upholdIssueSuccess: "upholdIssueSuccess",
    upholdIssueFailure: "upholdIssueFailure",
    getAuditUsersRequest: "getAuditUsersRequest",
    getAuditUsersSuccess: "getAuditUsersSuccess",
    getAuditUsersFailure: "getAuditUsersFailure",
    SET_PDF_PAGE_NUMBER: "SET_PDF_PAGE_NUMBER",
    SET_GROUNDING_HIGHLIGHT: "SET_GROUNDING_HIGHLIGHT",
    GET_AI_FEEDBACK_REQUEST: "GET_AI_FEEDBACK_REQUEST",
    GET_AI_FEEDBACK_SUCCESS: "GET_AI_FEEDBACK_SUCCESS",
    GET_AI_FEEDBACK_FAILURE: "GET_AI_FEEDBACK_FAILURE",
    SUBMIT_AI_FEEDBACK_REQUEST: "SUBMIT_AI_FEEDBACK_REQUEST",
    SUBMIT_AI_FEEDBACK_SUCCESS: "SUBMIT_AI_FEEDBACK_SUCCESS",
    SUBMIT_AI_FEEDBACK_FAILURE: "SUBMIT_AI_FEEDBACK_FAILURE",
    DELETE_AI_FEEDBACK_REQUEST: "DELETE_AI_FEEDBACK_REQUEST",
    DELETE_AI_FEEDBACK_SUCCESS: "DELETE_AI_FEEDBACK_SUCCESS",
    DELETE_AI_FEEDBACK_FAILURE: "DELETE_AI_FEEDBACK_FAILURE",
    SUBMIT_AI_FEEDBACK_BULK_REQUEST: "SUBMIT_AI_FEEDBACK_BULK_REQUEST",
    SUBMIT_AI_FEEDBACK_BULK_SUCCESS: "SUBMIT_AI_FEEDBACK_BULK_SUCCESS",
    SUBMIT_AI_FEEDBACK_BULK_FAILURE: "SUBMIT_AI_FEEDBACK_BULK_FAILURE",
    UNDO_AI_FEEDBACK_BULK_REQUEST: "UNDO_AI_FEEDBACK_BULK_REQUEST",
    UNDO_AI_FEEDBACK_BULK_SUCCESS: "UNDO_AI_FEEDBACK_BULK_SUCCESS",
    UNDO_AI_FEEDBACK_BULK_FAILURE: "UNDO_AI_FEEDBACK_BULK_FAILURE",
    createAIReviewEntityRequest: "createAIReviewEntityRequest",
    createAIReviewEntitySuccess: "createAIReviewEntitySuccess",
    createAIReviewEntityFailure: "createAIReviewEntityFailure",
    SET_CURRENT_FILE_TYPE: "SET_CURRENT_FILE_TYPE",
    updateReplaceDocumentRequest: "updateReplaceDocumentRequest",
    updateReplaceDocumentSuccess: "updateReplaceDocumentSuccess",
    updateReplaceDocumentFailure: "updateReplaceDocumentFailure",
    getCertificationTypesRequest: "getCertificationTypesRequest",
    getCertificationTypesSuccess: "getCertificationTypesSuccess",
    getCertificationTypesFailure: "getCertificationTypesFailure",
    setCertificationTemplateRequest: "setCertificationTemplateRequest",
    setCertificationTemplateSuccess: "setCertificationTemplateSuccess",
    setCertificationTemplateFailure: "setCertificationTemplateFailure",
    getCompleteStatusCheckRequest: "getCompleteStatusCheckRequest",
    getCompleteStatusCheckSuccess: "getCompleteStatusCheckSuccess",
    getCompleteStatusCheckFailure: "getCompleteStatusCheckFailure",
    getFeeSchedulesCheckRequest: "getFeeSchedulesCheckRequest",
    getFeeSchedulesCheckSuccess: "getFeeSchedulesCheckSuccess",
    getFeeSchedulesCheckFailure: "getFeeSchedulesCheckFailure",
    resetCompleteStatusCheck: "resetCompleteStatusCheck",
    resetFeeScheduleCheck: "resetFeeScheduleCheck",
    putTransactionLockSuccess: "putTransactionLockSuccess",
    runLateValidation: "runLateValidation",
    putTransactionLockFailure: "putTransactionLockFailure",
    getFacilityConfigurationRequest: "getFacilityConfigurationRequest",
    getFacilityConfigurationSuccess: "getFacilityConfigurationSuccess",
    getFacilityConfigurationFailure: "getFacilityConfigurationFailure",
    getIntakeIntelligenceRequest: "getIntakeIntelligenceRequest",
    getIntakeIntelligenceSuccess: "getIntakeIntelligenceSuccess",
    getIntakeIntelligenceFailure: "getIntakeIntelligenceFailure",
    requestIntakeIntelligenceRequest: "requestIntakeIntelligenceRequest",
    requestIntakeIntelligenceSuccess: "requestIntakeIntelligenceSuccess",
    requestIntakeIntelligenceFailure: "requestIntakeIntelligenceFailure",
    feedbackForIntakeFieldRequest: "feedbackForIntakeFieldRequest",
    feedbackForIntakeFieldSuccess: "feedbackForIntakeFieldSuccess",
    feedbackForIntakeFieldFailure: "feedbackForIntakeFieldFailure",
    // Spec #34102 (F1d), AC11/AC12: the only writer of classicModeOverride
    // (confirmed no writer existed before this Spec, via repo-wide search).
    setClassicModeOverride: "setClassicModeOverride",
} as const;

export type IntakeFeedbackApiStatus = {
    readonly [key in keyof RequestAnalysisData]?: ReduxApiStatus;
}

export interface DataEntryState {
    readonly activeTabId: number,
    readonly proceedBtnClick: boolean,
    readonly requestTypes: readonly RequestType[],
    readonly getRequestsAndPuposesAPIStatus: ReduxApiStatus,
    readonly transactionIDAttributes?: any,
    readonly isTransactionIdAssigned: boolean,
    readonly patientDetailsAttributes?: any,
    readonly leftPanePatientDetailsAttributes?: any,
    readonly transactionDetails?: TransactionDetails,
    readonly leftPaneTransactionDetails?: any,
    readonly discloseInstitutions: readonly any[],
    readonly getDiscloseInstitutionsAPIStatus: ReduxApiStatus,
    readonly requestorDetails?: any,
    readonly requestorContactDetails?: any,
    readonly feeSchedules: readonly FeeSchedule[],
    readonly releaseMethod: readonly NameIdPair<number>[],
    readonly requestComments: string,
    readonly releaseMethodAPIStatus: ReduxApiStatus,
    readonly shippingService: readonly any[],
    readonly getShippingServicesAPIStatus: ReduxApiStatus,
    readonly nextTransactionId?: any,
    readonly transactionNotes: readonly any[],
    readonly additionalChargeType: readonly any[],
    readonly getTransactionNotesAPIStatus: ReduxApiStatus,
    readonly getAdditionalChargeTypeAPIStatus: ReduxApiStatus,
    readonly getAdditionalChargeRecordsAPIStatus: ReduxApiStatus,
    readonly additionalChargeRecords?: any,
    readonly getRequestorSearchDetailsAPIStatus: ReduxApiStatus,
    readonly getContactSearchDetailsAPIStatus: ReduxApiStatus,
    readonly requestorSearchDetails: readonly any[],
    readonly patientSearchDetails: readonly any[],
    readonly rejectOptions: readonly any[],
    readonly contactSearchDetails: readonly any[],
    readonly uploadDocumentAPIStatus: ReduxApiStatus,
    readonly uploadDocumentFailure?: any,
    readonly postCancellationReasonsAPIStatus: ReduxApiStatus,
    readonly documentsList: readonly TransactionDocument[],
    readonly getTransactionDocumentsAPIStatus: ReduxApiStatus,
    readonly requestorBillingDetails?: any,
    readonly transactionNoteTypes: readonly any[],
    readonly createTransactionAPIStatus: 0,
    readonly createdTransactionDetails?: any,
    readonly documentFileById?: any,
    readonly documentSources: readonly any[],
    readonly rejectLetterData?: any,
    readonly rejectLetterDataState: ReduxApiStatus,
    readonly previousTransactionId?: any,
    readonly deleteDocumentAPIStatus: ReduxApiStatus,
    readonly deleteDocumentAPISuccess: string,
    readonly alertAPIFailure: ReduxApiStatus,
    readonly retrieveProtocolStatus: ReduxApiStatus,
    readonly retrieveProtocol: readonly any[],
    readonly transactionCancellationReasons: readonly any[],
    readonly selectedPHICodes: readonly any[],
    readonly selectedPHICodesAPIStatus: ReduxApiStatus,
    readonly phiCodes: readonly any[],
    readonly getPHICodesStatus: ReduxApiStatus,
    readonly getUserGroupsAPIStatus: ReduxApiStatus,
    readonly userGroups: readonly any[],
    readonly disclosureReasons: readonly any[],
    readonly formSyncErrors?: any,
    readonly userTasks: readonly any[],
    readonly getUserTasksStatus: ReduxApiStatus,
    readonly getAssessmentResultsStatus: ReduxApiStatus,
    readonly getReviewEntitiesStatus: ReduxApiStatus,
    readonly submitAIFeedbackStatus?: ReduxApiStatus,
    readonly userTaskComments?: any,
    readonly apiErrorArray: readonly any[],
    readonly popupErrorMessageArray: readonly any[],
    readonly rejectCompleted: boolean,
    readonly rightPaneUpdatedPatientDetailsAttributes?: any,
    readonly patientDetailsUpdated: boolean,
    readonly auditTypes: readonly any[],
    readonly onBehalfOf: readonly any[],
    readonly getAuditTypesAPIStatus: ReduxApiStatus,
    readonly getOBOsAPIStatus: ReduxApiStatus,
    readonly requestorVerificationEmailSent: boolean,
    readonly getValidation: ReduxApiStatus,
    readonly requestorVerificationEmailPopupTriggered: boolean,
    readonly getAuditTrailStatus: ReduxApiStatus,
    readonly auditTrail: readonly any[],
    readonly getStatusIndicatorStatus: ReduxApiStatus,
    readonly duplicateTransactions: readonly any[],
    readonly documentsToCopyList: readonly TransactionDocument[],
    readonly copyTransactionComplete: boolean,
    readonly postWPSStatus: ReduxApiStatus,
    readonly wpsToken: string,
    readonly lastUsedRequestorInfo?: any,
    readonly readBarCodeDDSAPIStatus: ReduxApiStatus,
    readonly readBarCodeDDS?: any,
    readonly completeTransactionFinished: boolean,
    readonly intiaTxlSagaCallCount: number,
    readonly FacilityAdditionalFields?: any,
    readonly FacilityAdditionalFieldsApiStatus: ReduxApiStatus,
    readonly transactionWaitAndHoldReasons: readonly any[],
    readonly updateDeliveryInstructionsStatus: ReduxApiStatus,
    readonly requestorComplete: boolean,
    readonly confirmFax: string,
    readonly assessmentResult?: AssessmentResult,
    readonly reviewEntities: readonly ReviewEntity[],
    readonly getSensitivityTypes: readonly EntityType[],
    readonly getSensitivityTypesStatus: ReduxApiStatus,
    readonly getQAErrorsStatus: ReduxApiStatus,
    readonly getQAErrors: readonly QaError[],
    readonly getQAIssuesStatus: ReduxApiStatus,
    readonly resolveQAIssueStatus: ReduxApiStatus,
    readonly removeQAIssueStatus: ReduxApiStatus,
    readonly disputeIssueStatus: ReduxApiStatus,
    readonly upholdIssueStatus: ReduxApiStatus,
    readonly getQAIssues: readonly TransactionIssue[],
    readonly getQAPDIssuesStatus: ReduxApiStatus,
    readonly qaPDIssues: readonly TransactionIssue[],
    readonly postQATransactionIssueStatus: ReduxApiStatus,
    readonly getAuditUsersStatus: ReduxApiStatus,
    readonly auditUsers: readonly any[],
    readonly updateReplaceDocumentStatus: ReduxApiStatus,
    readonly getCertificationTypesStatus: ReduxApiStatus,
    readonly certificationTypes: readonly any[],
    readonly setCertificationTemplateStatus: ReduxApiStatus,
    readonly getCompleteStatusCheckStatus: ReduxApiStatus,
    readonly completeStatusCheck?: any,
    readonly currentFile: string,
    readonly facilityConfiguration?: FacilityConfiguration,
    readonly requestAnalysis?: RequestAnalysis,
    readonly getIntakeIntelligenceStatus: ReduxApiStatus,
    readonly requestIntakeIntelligenceStatus: ReduxApiStatus,
    readonly intakeFeedbackSubmitStatus: IntakeFeedbackApiStatus;
    /** Spec #34102 (F1d), AC11/AC12: one-way Classic-Mode-exit override - once true, Quick Entry is never eligible again for this transaction (isQuickEntryEligible() ANDs on !classicModeOverride). */
    readonly classicModeOverride: boolean;
}

const defaultState: DataEntryState = {
    activeTabId: 1,
    proceedBtnClick: false,
    requestTypes: [],
    getRequestsAndPuposesAPIStatus: API_INITIAL,
    transactionIDAttributes: {},
    isTransactionIdAssigned: false,
    patientDetailsAttributes: {},
    leftPanePatientDetailsAttributes: {},
    transactionDetails: undefined,
    leftPaneTransactionDetails: {},
    discloseInstitutions: [],
    getDiscloseInstitutionsAPIStatus: API_INITIAL,
    requestorDetails: undefined,
    requestorContactDetails: undefined,
    feeSchedules: [],
    releaseMethod: [],
    requestComments: '',
    releaseMethodAPIStatus: API_INITIAL,
    shippingService: [],
    getShippingServicesAPIStatus: API_INITIAL,
    nextTransactionId: null,
    transactionNotes: [],
    additionalChargeType: [],
    getTransactionNotesAPIStatus: API_INITIAL,
    getAdditionalChargeTypeAPIStatus: API_INITIAL,
    getAdditionalChargeRecordsAPIStatus: API_INITIAL,
    additionalChargeRecords: {},
    getRequestorSearchDetailsAPIStatus: API_INITIAL,
    getContactSearchDetailsAPIStatus: API_INITIAL,
    requestorSearchDetails: [],
    patientSearchDetails: [],
    rejectOptions: [],
    contactSearchDetails: [],
    uploadDocumentAPIStatus: API_INITIAL,
    uploadDocumentFailure: null,
    postCancellationReasonsAPIStatus: API_INITIAL,
    documentsList: [],
    getTransactionDocumentsAPIStatus: API_INITIAL,
    requestorBillingDetails: {},
    transactionNoteTypes: [],
    createTransactionAPIStatus: 0,
    createdTransactionDetails: {},
    documentFileById: {},
    documentSources: [],
    rejectLetterData: {},
    rejectLetterDataState: API_INITIAL,
    previousTransactionId: {},
    deleteDocumentAPIStatus: API_INITIAL,
    deleteDocumentAPISuccess: '',
    alertAPIFailure: API_INITIAL,
    retrieveProtocolStatus: API_INITIAL,
    retrieveProtocol: [],
    transactionCancellationReasons: [],
    selectedPHICodes: [],
    selectedPHICodesAPIStatus: API_INITIAL,
    phiCodes: [],
    getPHICodesStatus: API_INITIAL,
    getUserGroupsAPIStatus: API_INITIAL,
    userGroups: [],
    disclosureReasons: [],
    formSyncErrors: {},
    userTasks: [],
    getUserTasksStatus: API_INITIAL,
    getAssessmentResultsStatus: API_INITIAL,
    getReviewEntitiesStatus: API_INITIAL,
    userTaskComments: {},
    apiErrorArray: [],
    popupErrorMessageArray: [],
    rejectCompleted: false,
    rightPaneUpdatedPatientDetailsAttributes: {},
    patientDetailsUpdated: false,
    auditTypes: [],
    onBehalfOf: [],
    getAuditTypesAPIStatus: API_INITIAL,
    getOBOsAPIStatus: API_INITIAL,
    requestorVerificationEmailSent: false,
    getValidation: API_INITIAL,
    requestorVerificationEmailPopupTriggered: false,
    getAuditTrailStatus: API_INITIAL,
    auditTrail: [],
    getStatusIndicatorStatus: API_INITIAL,
    duplicateTransactions: [],
    documentsToCopyList: [],
    copyTransactionComplete: false,
    postWPSStatus: API_INITIAL,
    wpsToken: "",
    lastUsedRequestorInfo: {},
    readBarCodeDDSAPIStatus: API_INITIAL,
    readBarCodeDDS: {},
    completeTransactionFinished: false,
    intiaTxlSagaCallCount: 0,
    FacilityAdditionalFields: {},
    FacilityAdditionalFieldsApiStatus: API_INITIAL,
    transactionWaitAndHoldReasons: [],
    updateDeliveryInstructionsStatus: API_INITIAL,
    requestorComplete: false,
    confirmFax: "",
    assessmentResult: undefined,
    reviewEntities: [],
    getSensitivityTypes: [],
    getSensitivityTypesStatus: API_INITIAL,
    getQAErrorsStatus: API_INITIAL,
    getQAErrors: [],
    getQAIssuesStatus: API_INITIAL,
    resolveQAIssueStatus: API_INITIAL,
    removeQAIssueStatus: API_INITIAL,
    disputeIssueStatus: API_INITIAL,
    upholdIssueStatus: API_INITIAL,
    getQAIssues: [],
    getQAPDIssuesStatus: API_INITIAL,
    qaPDIssues: [],
    postQATransactionIssueStatus: API_INITIAL,
    getAuditUsersStatus: API_INITIAL,
    auditUsers: [],
    updateReplaceDocumentStatus: API_INITIAL,
    getCertificationTypesStatus: API_INITIAL,
    certificationTypes: [],
    setCertificationTemplateStatus: API_INITIAL,
    getCompleteStatusCheckStatus: API_INITIAL,
    completeStatusCheck: {},
    currentFile: "",
    facilityConfiguration: undefined,
    requestAnalysis: undefined,
    getIntakeIntelligenceStatus: API_INITIAL,
    requestIntakeIntelligenceStatus: API_INITIAL,
    intakeFeedbackSubmitStatus: {},
    classicModeOverride: false,
} as const;

export interface sendToRequestorDataProps {
    transactionID: String;
    requestBody: {
        code?: String;
        requestorname: String;
        firstname: String;
        lastname: String;
        address1: String;
        address2?: String;
        city: String;
        state: String;
        zipcode: String;
        country: String;
        prePay?: Boolean;
        attentionto?: String;
        email: String;
        phone: String;
        fax?: String;
        isverified: Boolean;
        userID: Number;
    }
}

/**
 * @deprecated replaced by NewSendToContact
 */
export interface sendToContactDataProps {
    requestorID: String;
    contactBody: {
        firstname: String;
        lastname: String;
        email: String;
        phone: String;
        fax?: String;
        isverified: Boolean;
        userID: Number;
    }
}

export interface updateAdditionalChargesProps {
    transactionID: String;
    requestData: {
        id?: Number;
        glCodeID: Number;
        description: String;
        chargeAmount: Number;
    }
}

export interface qaReviewEntityProps {
    docAIProcessId: string;
    typeId: string;
    /**
     * @deprecated Not used
     */
    documentFilename: string;
    page: number;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    highlightText: string;
    organizationID: number;
    requestBufferID: number;
    userId: number;
}


export const dataEntryState = (state: any = defaultState, action: AnyAction): any => {
    switch (action.type) {
        case DataEntryActionConstants.onChangeTab:
            return {
                ...state,
                activeTabId: action.data,
                proceedBtnClick: action.tabClick ? false : true
            }
        case DataEntryActionConstants.getRequestTypesAndPurposesRequest:
            return {
                ...state,
                getRequestsAndPuposesAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getRequestTypesAndPurposesSuccess:
            return {
                ...state,
                requestTypes: action.data,
                getRequestsAndPuposesAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.getRequestTypesAndPurposesFailure:
            return {
                ...state,
                getRequestsAndPuposesAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.GET_TRANSACTIONS_ATTRIBUTES:
            return {
                ...state,
                transactionIDAttributes: { ...action.data }
            }
        case DataEntryActionConstants.ASSIGN_TRANSACTION_ID:
            return {
                ...state,
                isTransactionIdAssigned: action.data,
                completeTransactionFinished: false
            }
        case DataEntryActionConstants.GET_TRANSACTIONS_PATIENT_ATTRIBUTES:
            return {
                ...state,
                patientDetailsAttributes: { ...action.data },
                leftPanePatientDetailsAttributes: { ...action.data }
            }
        case DataEntryActionConstants.getTransactionDetailsSuccess:
            return {
                ...state,
                transactionDetails: {
                    ...action.data,
                    releaseInfo: action.data.releaseInfo.map(info => ({
                        ...info,
                        dateOfService: info.dateOfService ? {
                            from: info.dateOfService.from ? new Date(info.dateOfService.from) : undefined,
                            to: info.dateOfService.to ? new Date(info.dateOfService.to) : undefined,
                        } : undefined
                    }))
                },
                leftPaneTransactionDetails: action.data,
                completeTransactionFinished: false
            }
        case DataEntryActionConstants.getDefaultFeeSchedule:
            return {
                ...state,
                transactionDetails: state.transactionDetails ? {
                    ...state.transactionDetails,
                    feeSchedule: action.data
                } : undefined,
            }
        case DataEntryActionConstants.getFacilityDiscloseInstitutionsSuccess:
            return {
                ...state,
                discloseInstitutions: action.data,
                getDiscloseInstitutionsAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.getFacilityDiscloseInstitutionsFailure:
            return {
                ...state,
                getDiscloseInstitutionsAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.getFacilityDiscloseInstitutionsRequest:
            return {
                ...state,
                getDiscloseInstitutionsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getRequestorDetailsSuccess:
            return {
                ...state,
                requestorDetails: action.data,
            }
        case DataEntryActionConstants.getContactDetailsSuccess:
            return {
                ...state,
                requestorContactDetails: action.data
            }
        case DataEntryActionConstants.updatePatientDetails:
            return {
                ...state,
                leftPanePatientDetailsAttributes: updatePatientDetails({ ...state }, action.data),
                rightPaneUpdatedPatientDetailsAttributes: updatePatientDetailsRightPane({ ...state }, action.data),
                patientDetailsUpdated: true
            }
        case DataEntryActionConstants.updateRequestorDetails:
            return {
                ...state,
                requestorDetails: updateRequestorDetails(state, action.data)
            }
        case DataEntryActionConstants.setRequestorDetails: {
            const transaction: TransactionDetails | undefined = state.transactionDetails;
            const requestor: Requestor | undefined = action.requestor;
            const contact = requestor?.requestorInfo;

            const prevRequestorId = transaction?.sendToRequestor?.id;
            const nextRequestorId = requestor?.requestorID;
            const requestorChanged = prevRequestorId != null && nextRequestorId != null && prevRequestorId !== nextRequestorId;

            return {
                ...state,
                requestorDetails: requestor && { ...requestor },
                transactionDetails: transaction && {
                    ...transaction,
                    ...(requestor && {
                        sendToRequestor: {
                            name: requestor.fullName,
                            id: requestor.requestorID,
                        },
                    }),
                    ...(contact
                        ? {
                            sendToContact: {
                                name: contact.firstName + " " + contact.lastName,
                                id: contact.id,
                            },
                        }
                        : requestorChanged
                            ? { sendToContact: undefined }
                            : {}),
                } as TransactionDetails,
            };
        }
        case DataEntryActionConstants.setRequestorContact:
            const transaction: TransactionDetails | undefined = state.transactionDetails;
            const requestor: Requestor | undefined = state.requestorDetails;
            const contact: Contact | undefined = action.contact;
            return requestor ? {
                ...state,
                requestorDetails: {
                    ...requestor,
                    requestorInfo: contact && { ...contact },
                },
                transactionDetails: transaction && {
                    ...transaction,
                    sendToContact: contact && {
                        name: contact.firstName + " " + contact.lastName,
                        id: contact.id,
                    }
                }
            } : state;
        case DataEntryActionConstants.updateTransactionDetails:
            return {
                ...state,
                leftPaneTransactionDetails: updateTransactionDetails({ ...state }, action.data)
            }
        case DataEntryActionConstants.GET_FEE_SCHEDULE_SUCCESS:
            return {
                ...state,
                feeSchedules: action.data,
            }
        // AB#39575: previously a no-op - a failed fetch left this slot holding whatever the
        // PREVIOUS transaction's fee schedules were, indefinitely, with no signal beyond the
        // generic API_ERROR_STATE the saga already dispatches alongside this.
        case DataEntryActionConstants.getFeeScheduleFailure:
            return {
                ...state,
                feeSchedules: [],
            }
        case DataEntryActionConstants.getTransactionNotesRequest:
            return {
                ...state,
                getTransactionNotesAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getTransactionNotesSuccess:
            return {
                ...state,
                getTransactionNotesAPIStatus: API_SUCCESS,
                transactionNotes: action.data
            }
        case DataEntryActionConstants.getTransactionNotesFailure:
            return {
                ...state,
                getTransactionNotesAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.getAdditionalChargeTypeSuccess:
            return {
                ...state,
                getAdditionalChargeTypeAPIStatus: API_SUCCESS,
                additionalChargeType: normalizeData(action.data, "id")
            }

        case DataEntryActionConstants.getAdditionalChargeTypeFailure:
            return {
                ...state,
                getAdditionalChargeTypeAPIStatus: API_FAILURE,

            }
        case DataEntryActionConstants.getAdditionalChargeRecordsSuccess:
            return {
                ...state,
                getAdditionalChargeRecordsAPIStatus: API_SUCCESS,
                additionalChargeRecords: normalizeData(action.data, "id")
            }
        case DataEntryActionConstants.getRequestorSearchDetailsSuccess:
            return {
                ...state,
                getRequestorSearchDetailsAPIStatus: API_SUCCESS,
                requestorSearchDetails: generateSearchResponseObject(action.data)
            }
        case DataEntryActionConstants.getRequestorSearchDetailsFailure:
            return {
                ...state,
                getRequestorSearchDetailsAPIStatus: API_FAILURE,
                requestorSearchDetails: action.data
            }
        case DataEntryActionConstants.getRequestorSearchDetailsSAGA:
            return {
                ...state,
                getRequestorSearchDetailsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getContactSeacrhDetailsReset:
            return {
                ...state,
                getContactSearchDetailsAPIStatus: API_INITIAL,
                requestorContactDetails: undefined,
                contactSearchDetails: []
            }
        case DataEntryActionConstants.getContactSeacrhDetailsSuccess:
            return {
                ...state,
                getContactSearchDetailsAPIStatus: API_SUCCESS,
                contactSearchDetails: generateContactSearchReponseObject(action.data)
            }
        case DataEntryActionConstants.getContactSearchDetailsFailure:
            return {
                ...state,
                getContactSearchDetailsAPIStatus: API_FAILURE,
                contactSearchDetails: action.data
            }
        case DataEntryActionConstants.getContactSearchDetailsSAGA:
            return {
                ...state,
                getContactSearchDetailsAPIStatus: API_FETCHING,
                contactSearchDetails: []
            }
        case DataEntryActionConstants.GET_PATIENT_SEARCH_DETAILS:
            return {
                ...state,
                patientSearchDetails: action.data,
                getPatientSearchResultsAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.GET_PATIENT_SEARCH_DETAILS_FAILURE:
            return {
                ...state,
                getPatientSearchResultsAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.getRejectOptionsSuccess:
            return {
                ...state,
                rejectOptions: generatePickerOptions(action.data, "name", "description", "id")
            }
        case DataEntryActionConstants.getTransactionDocumentsRequest:
            return {
                ...state,
                getTransactionDocumentsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getTransactionDocumentsSuccess:
            return {
                ...state,
                copyTransactionComplete: false,
                getTransactionDocumentsAPIStatus: API_SUCCESS,
                deleteDocumentAPIStatus: API_INITIAL,
                documentsList: action.data.map(documentFromApiResponse)
            }
        case DataEntryActionConstants.getTransactionDocumentsFailure:
            return {
                ...state,
                getTransactionDocumentsAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.getShippingServicesSuccess:
            return {
                ...state,
                getShippingServicesAPIStatus: API_SUCCESS,
                shippingService: generatePickerOptions(action.data, "name", "name")
            }
        case DataEntryActionConstants.getShippingServicesFailure:
            return {
                ...state,
                getShippingServicesAPIStatus: API_FAILURE,
            }
        case DataEntryActionConstants.getReleaseMethodOptionsSuccess:
            return {
                ...state,
                releaseMethodAPIStatus: API_SUCCESS,
                releaseMethod: action.data
            }
        case DataEntryActionConstants.getReleaseMethodOptionsFailure:
            return {
                ...state,
                releaseMethodAPIStatus: API_FAILURE,
            }
        case DataEntryActionConstants.setReleaseMethod:
            const releaseMethod = state.releaseMethod?.find((x: NameIdPair<number>) => x.id == action.data);
            return {
                ...state,
                transactionDetails: state.transactionDetails && {
                    ...state.transactionDetails,
                    releaseMethod,
                } as TransactionDetails
            }
        case DataEntryActionConstants.uploadDocumentRequest:
            return {
                ...state,
                uploadDocumentAPIStatus: API_FETCHING,
                uploadDocumentFailure: null,
                uploadDocumentSuccess: null
            }
        case DataEntryActionConstants.uploadDocumentSuccess:
            return {
                ...state,
                uploadDocumentAPIStatus: API_SUCCESS,
                uploadDocumentFailure: null,
                uploadDocumentSuccess: action.data
            }
        case DataEntryActionConstants.uploadDocumentFailure:
            return {
                ...state,
                uploadDocumentAPIStatus: API_FAILURE,
                uploadDocumentFailure: action.data,
                uploadDocumentSuccess: null
            }
        case DataEntryActionConstants.uploadDocumentInitial:
            return {
                ...state,
                uploadDocumentAPIStatus: API_INITIAL,
                uploadDocumentFailure: null,
                uploadDocumentSuccess: null
            }
        case DataEntryActionConstants.postCancellationReasonsSuccess:
            return {
                ...state,
                postCancellationReasonsAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.postCancellationReasonsRequest:
            return {
                ...state,
                postCancellationReasonsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getTransactionNoteTypesSuccess:
            return {
                ...state,
                transactionNoteTypes: generatePickerOptionsNew(action.data, "name", "id")
            }
        case DataEntryActionConstants.getRequestorBillingDetailsSuccess:
            if (state.requestorDetails?.prePay) {
                action.data.prePay = true;
            }
            return {
                ...state,
                requestorBillingDetails: action.data
            }
        case DataEntryActionConstants.UPDATE_ADDITIONAL_CHARGES:
            return {
                ...state,
                updateAdditionalChargesSuccess: action.data
            }
        case DataEntryActionConstants.GET_NEXT_TRANSACTION_REQUEST:
            return {
                ...defaultState,
                nextTransactionId: action.data,
                completeTransactionFinished: false
            }
        case DataEntryActionConstants.getDocumentByIdSuccess:
            return {
                ...state,
                documentFileById: action.data,
                getDocumentAPIstatus: API_SUCCESS
            }
        case DataEntryActionConstants.getDocumentByIdFailure:
            return {
                ...state,
                getDocumentAPIstatus: API_FAILURE
            }
        case DataEntryActionConstants.resetState:
            return {
                ...defaultState,
                lastUsedRequestorInfo: state.lastUsedRequestorInfo
            }
        case DataEntryActionConstants.getDocumentSourcesSuccess:
            return {
                ...state,
                documentSources: generatePickerOptionsUndefinedDefault(action.data, "name", "id")
            }
        case DataEntryActionConstants.getRejectionLetterDataAPISuccess:
            return {
                ...state,
                rejectLetterData: generateRejectLetterResponseObject(action.data),
                rejectLetterDataState: API_SUCCESS,
                rejectCompleted: false
            }
        case DataEntryActionConstants.getRejectionLetterDataAPIInitial:
            return {
                ...state,
                rejectLetterDataState: API_INITIAL
            }
        case DataEntryActionConstants.getPreviousTransactionAPISuccess:
            return {
                ...state,
                previousTransactionId: action.data
            }
        case DataEntryActionConstants.getPreviousTransactionAPIFailure:
            return {
                ...state,
                alertAPIFailure: API_FAILURE
            }

        case DataEntryActionConstants.getRequestorBillingDetailsFailure:
            return {
                ...state,
                getBillToRequestorDetailsAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.deleteDocumentAPIInitial:
            return {
                ...state,
                deleteDocumentAPISuccess: null,
                deleteDocumentAPIStatus: API_INITIAL
            }
        case DataEntryActionConstants.deleteDocumentAPISuccess:
            return {
                ...state,
                deleteDocumentAPISuccess: action.data,
                deleteDocumentAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.deleteDocumentAPIFailure:
            return {
                ...state,
                deleteDocumentAPISuccess: false,
                deleteDocumentAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.SET_NEXT_TRANSACTION_NULL:
            return {
                ...state,
                nextTransactionId: null
            }
        case DataEntryActionConstants.SET_LAST_USED_REQUESTOR:
            return {
                ...state,
                lastUsedRequestorInfo: action.data
            }
        case DataEntryActionConstants.getRetrieveProtocolRequest:
            return {
                ...state,
                retrieveProtocolStatus: API_FETCHING
            }
        case DataEntryActionConstants.getRetrieveProtocolSuccess:
            return {
                ...state,
                retrieveProtocolStatus: API_SUCCESS,
                retrieveProtocol: action.data
            }
        case DataEntryActionConstants.getRetrieveProtocolFailure:
            return {
                ...state,
                retrieveProtocolStatus: API_FAILURE
            }
        case DataEntryActionConstants.getCancellationReasonsSuccess:
            return {
                ...state,
                transactionCancellationReasons: generatePickerOptions(action.data, "reason", "id"),
                transactionCancellationReasonsAPISuccess: API_SUCCESS
            }
        case DataEntryActionConstants.getCancellationReasonsFailure:
            return {
                ...state,
                transactionCancellationReasonsAPIFailure: API_FAILURE
            }
        case DataEntryActionConstants.getSelectedPHICodesSuccess:
            return {
                ...state,
                selectedPHICodes: action.data,
                selectedPHICodesAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.getSelectedPHICodesFailure:
            return {
                ...state,
                selectedPHICodesAPIStatus: API_FAILURE
            }

        case DataEntryActionConstants.getPHICodesRequest:
            return {
                ...state,
                getPHICodesStatus: API_FETCHING
            }
        case DataEntryActionConstants.getPHICodesSuccess:
            return {
                ...state,
                getPHICodesStatus: API_SUCCESS,
                phiCodes: action.data
            }
        case DataEntryActionConstants.createPatientRecordSuccess:
            return {
                ...state,
                transactionDetails: state.transactionDetails ? updatePatientDetailsForTransaction(state.transactionDetails, action.data.id) : undefined,
                leftPaneTransactionDetails: state.leftPaneTransactionDetails ? updatePatientDetailsForTransaction(state.leftPaneTransactionDetails, action.data.id) : undefined,
            }
        case DataEntryActionConstants.POST_REJECTION_ACTION:
            return {
                ...state,
                postRejectionActionSuccess: action.data,
                rejectCompleted: true
            }
        case DataEntryActionConstants.POST_REJECTION_ACTION_FAILURE:
            return {
                ...state,
                rejectCompleted: true
            }
        case DataEntryActionConstants.getUserGroupsRequest:
            return {
                ...state,
                getUserGroupsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getUserGroupsSuccess:
            let groupList = action.data.filter(item => item.name.split(",").length <= 1)
            groupList.sort(compare)
            let individualsList = action.data.filter(item => item.name.split(",").length > 1)
            individualsList.sort(compareIndividuals)
            let updatedList = groupList.concat(individualsList)
            let options = generatePickerOptions(updatedList, "name", "id")
            options.shift()
            return {
                ...state,
                getUserGroupsAPIStatus: API_SUCCESS,
                userGroups: options
            }
        case DataEntryActionConstants.GET_DISCLOSURE_REASON:
            return {
                ...state,
                disclosureReasons: generatePickerOptions(action.data, "name", "id")
            }
        case DataEntryActionConstants.updateFormSyncErrors:
            return {
                ...state,
                formSyncErrors: {
                    ...state.formSyncErrors,
                    ...action.data
                }
            }
        case DataEntryActionConstants.UPDATE_DISCLOSURE_INFORMATION:
            return {
                ...state,
                updateDisclosureInformationSucess: action.data
            }
        case DataEntryActionConstants.getUserTasksRequest:
            return {
                ...state,
                getUserTasksStatus: API_FETCHING
            }
        case DataEntryActionConstants.getUserTasksSuccess:
            return {
                ...state,
                getUserTasksStatus: API_SUCCESS,
                userTasks: action.data,
                userTaskComments: action.comments
            }
        case DataEntryActionConstants.getUserTasksFailure:
            return {
                ...state,
                getUserTasksStatus: API_FAILURE,
            }
        case DataEntryActionConstants.GET_ASSESSMENT_RESULTS:
            return {
                ...state,
                getAssessmentResultsStatus: API_FETCHING
            }
        case DataEntryActionConstants.GET_ASSESSMENT_RESULTS_SUCCESS:
            return {
                ...state,
                getAssessmentResultsStatus: API_SUCCESS,
                assessmentResult: action.data && {
                    ...action.data,
                    reviewEntities: action.data.reviewEntities.map((ent: any) => ({
                        ...ent,
                        submitted: new Date(ent.submitted),
                    })),
                    patientNameMissingPages: action.data.patientNameMissingPages
                },
            }
        case DataEntryActionConstants.GET_ASSESSMENT_RESULTS_FAILURE:
            return {
                ...state,
                getAssessmentResultsStatus: API_FAILURE,
            }
        case DataEntryActionConstants.GET_REVIEW_ENTITIES:
            return {
                ...state,
                getReviewEntitiesStatus: API_FETCHING
            }
        case DataEntryActionConstants.GET_REVIEW_ENTITIES_SUCCESS: {
            const entities: ReviewEntity[] = action.data.map((ent: any) => ({
                ...ent,
                submitted: new Date(ent.submitted),
            }))
            return {
                ...state,
                getReviewEntitiesStatus: API_SUCCESS,
                reviewEntities: entities,
                assessmentResult: state.assessmentResult && {
                    ...state.assessmentResult,
                    reviewEntities: entities,
                }
            }
        }
        case DataEntryActionConstants.GET_REVIEW_ENTITIES_FAILURE:
            return {
                ...state,
                getReviewEntitiesStatus: API_FAILURE,
            }
        case DataEntryActionConstants.updateUserTasksList:
            return {
                ...state,
                userTasks: updateUserTaskDetailsHelperFunction([...state.userTasks], action.data.index, action.data.updatedData, action.data.isNewTask)
            }
        case DataEntryActionConstants.updateUserTaskComments:
            return {
                ...state,
                userTaskComments: updateUserTaskCommentsHelperFunction({ ...state.userTaskComments }, action.data)
            }
        case DataEntryActionConstants.DELETE_TRANSACTION_TASK:
            let tempState = { ...state }
            let tempTaskArray: any = tempState.userTasks;
            let newTaskArray: any = [];
            for (let i = 0; i < tempTaskArray.length; i++) {
                if (tempTaskArray[i].id !== action.data) {
                    newTaskArray.push(tempTaskArray[i]);
                }
            }
            return {
                ...state,
                userTasks: newTaskArray
            }
        case DataEntryActionConstants.API_ERROR_STATE:
            if (action.data) {
                let tempApiErrorArray: any = [...state.apiErrorArray]

                let dataObj: any = {
                    status: action.data ? action.data.status : '',
                    statusText: action.data ? action.data.statusText : '',
                    responseURL: action.data ? action.data.request?.responseURL : ''
                }

                if (Array.isArray(action.data?.data)) {
                    dataObj.messages = action.data.data.map(d => ({ code: d.code, message: d.message }));
                } else {
                    dataObj.code = action.data ? action.data.data?.code : '';
                    dataObj.message = action.data ? action.data.data?.message : ''
                }

                dataObj.id = tempApiErrorArray.length;
                dataObj.showAlert = true;
                tempApiErrorArray.push(dataObj);

                return {
                    ...state,
                    apiErrorArray: tempApiErrorArray,
                }
            } else {
                return state
            }
        case DataEntryActionConstants.HIDE_API_ERROR_MESSAGE:
            let tempApiErrorArr: any = [...state.apiErrorArray]
            tempApiErrorArr[action.data].showAlert = false
            return {
                ...state,
                apiErrorArray: tempApiErrorArr,
            }
        case DataEntryActionConstants.POPUP_ERROR_STATE:
            if (action.data) {
                return {
                    ...state,
                    popupErrorMessageHeader: action.data?.popupErrorHeader,
                    popupErrorMessageBody: action.data?.popupErrorBody,
                    popupErrorMessageArray: action.data?.popupErrorMessages ?? []
                }
            } else {
                return state
            }
        case DataEntryActionConstants.HIDE_POPUP_ERROR_MESSAGE:
            return {
                ...state,
                popupErrorMessageArray: null,
                popupErrorMessageHeader: null
            }
        case DataEntryActionConstants.COMPLETE_TRANSACTION_REQUEST:
            return {
                ...state,
                completeTransactionRequestSucess: action.data,
                completeTransactionFinished: true
            }
        case DataEntryActionConstants.GET_PATIENT_SEARCH_DETAILS_SAGA:
            return {
                ...state,
                getPatientSearchResultsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.patchPatientDetails:
            return {
                ...state,
                patientDetailsUpdated: false,
                rightPaneUpdatedPatientDetailsAttributes: {}
            }
        case DataEntryActionConstants.getAuditTypesRequest:
            return {
                ...state,
                getAuditTypesAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getAuditTypesSuccess:
            return {
                ...state,
                auditTypes: action.data,
                getAuditTypesAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.getAuditTypesFailure:
            return {
                ...state,
                getAuditTypesAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.getOBOsRequest:
            return {
                ...state,
                getOBOAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getOBOsSuccess:
            return {
                ...state,
                onBehalfOf: action.data,
                getOBOsAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.getOBOsFailure:
            return {
                ...state,
                getOBOsAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.getValidateRequest:
            return {
                ...state,
                getValidation: API_FETCHING
            }
        case DataEntryActionConstants.getValidateSuccess:
            return {
                ...state,
                getValidation: API_SUCCESS
            }
        case DataEntryActionConstants.getValidateFailure:
            return {
                ...state,
                getValidation: API_FAILURE
            }
        case DataEntryActionConstants.requestorVerificationEmailSent:
            return {
                ...state,
                requestorVerificationEmailSent: true,
            }

        case DataEntryActionConstants.requestorVerificationEmailSentReset:
            return {
                ...state,
                requestorVerificationEmailSent: false
            }
        case DataEntryActionConstants.getAuditTrailRequest:
            return {
                ...state,
                getAuditTrailStatus: API_FETCHING
            }
        case DataEntryActionConstants.getAuditTrailResponse:
            return {
                ...state,
                auditTrail: action.data,
                getAuditTrailStatus: API_INITIAL
            }
        case DataEntryActionConstants.getStatusIndicatorRequest:
            return {
                ...state,
                getStatusIndicatorStatus: API_FETCHING
            }
        case DataEntryActionConstants.getStatusIndicatorResponse:
            return {
                ...state,
                getStatusIndicatorStatus: API_INITIAL,
                transactionDetails: state.transactionDetails ? {
                    ...state.transactionDetails,
                    transactionStatus: action.data
                } : undefined,
            }
        case DataEntryActionConstants.SHOW_DUPLICATE_TRANSACTIONS:
            if (action.data) {
                return {
                    ...state,
                    duplicateTransactions: action.data.duplicates,
                }
            } else {
                return state
            }
        case DataEntryActionConstants.HIDE_DUPLICATE_TRANSACTIONS:
            return {
                ...state,
                duplicateTransactions: null
            }
        case DataEntryActionConstants.getTransactionDocumentsToCopyRequest:
            return {
                ...state,
                getTransactionDocumentsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.getTransactionDocumentsToCopySuccess:
            return {
                ...state,
                getTransactionDocumentsAPIStatus: API_SUCCESS,
                documentsToCopyList: action.data
                    .filter((row: any) => row.type.role === DocTypes.MED)
                    .map(documentFromApiResponse),
            }
        case DataEntryActionConstants.resetTransactionDocumentsToCopyRequest:
            return {
                ...state,
                documentsToCopyList: [],
                copyTransactionComplete: false,
            }
        case DataEntryActionConstants.patchTransactionOnFileSuccess:
            return {
                ...state,
                copyTransactionComplete: true,
                documentsToCopyList: []
            }
        case DataEntryActionConstants.patchTransactionOnFileFailure:
            return {
                ...state,
                copyTransactionComplete: true,
                documentsToCopyList: []
            }
        case DataEntryActionConstants.postWPSRequest:
            return {
                ...state,
                transactionId: action.data.transactionId,
                docType: action.data.docType,
                postWPSStatus: API_FETCHING
            }
        case DataEntryActionConstants.postWPSResponse:
            return {
                ...state,
                wpsToken: action.data,
                postWPSStatus: API_INITIAL
            }
        case DataEntryActionConstants.clearPreviousTransactionOnComplete:
            return {
                ...defaultState,
                lastUsedRequestorInfo: state.lastUsedRequestorInfo,
                sendToContactDataProps: null,
                updateAdditionalChargesProps: null,
                sendToRequestorDataProps: null,
                completeTransactionFinished: true
            }
        case DataEntryActionConstants.readBarCodeDDSRequest:
            return {
                ...state,
                readBarCodeDDSAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.readBarCodeDDSSuccess:
            return {
                ...state,
                readBarCodeDDSAPIStatus: API_SUCCESS,
                readBarCodeDDS: action.data

            }
        case DataEntryActionConstants.readBarCodeDDSFailure:
            return {
                ...state,
                readBarCodeDDSAPIStatus: API_FAILURE
            }
        case DataEntryActionConstants.COMPLETE_TRANSACTION_REQUEST_SAGA:
            return {
                ...state,
                completeTransactionFinished: true
            }
        case DataEntryActionConstants.initialTxCountIncrement:
            return {
                ...state,
                intiaTxlSagaCallCount: state.intiaTxlSagaCallCount + 1
            }

        case DataEntryActionConstants.getFacilityAdditionalFieldsRequest:
            return {
                ...state,
                FacilityAdditionalFieldsApiStatus: API_FETCHING
            }

        case DataEntryActionConstants.getFacilityAdditionalFieldsSuccess:
            return {
                ...state,
                FacilityAdditionalFields: action.data,
                FacilityAdditionalFieldsApiStatus: API_SUCCESS
            }

        case DataEntryActionConstants.getFacilityAdditionalFieldsFailure:
            return {
                ...state,
                FacilityAdditionalFieldsApiStatus: API_FAILURE
            }
        case DataEntryActionConstants.saveInformationToReleaseResponse: {
            if (action.data.freeText) {
                return {
                    ...state,
                    transactionDetails: state.transactionDetails ? {
                        ...state.transactionDetails,
                        releaseInfo: action.data.returnItem,
                        requestComments: action.data.freeText,
                    } : undefined,
                }
            } else {
                return {
                    ...state,
                    transactionDetails: state.transactionDetails ? {
                        ...state.transactionDetails,
                        releaseInfo: action.data.returnItem
                    } : undefined,
                }
            }
        }
        case DataEntryActionConstants.saveInformationToRelease: {
            const data: ReleaseInfoUpdate = action.data;
            return {
                ...state,
                transactionDetails: state.transactionDetails ? {
                    ...state.transactionDetails,
                    // AB#39380: the write carries the Other Documents description, and classic's
                    // left pane reads transactionDetails.requestComments directly - so leaving it
                    // at its pre-session value had that pane showing the previous description (or
                    // none) while the Quick Entry row and the Records pane showed the new one
                    // (Mike Hamilton, PR !10721 round 3). Left alone when the payload omits it,
                    // so Classic's own call sites are unaffected.
                    requestComments: data.requestComments
                        ?? (state.transactionDetails as TransactionDetails).requestComments,
                    releaseInfo: (state.transactionDetails as TransactionDetails).releaseInfo.map(item => ({
                        ...item,
                        checked: data.releases.includes(item.id),
                        dateOfService: data.from && data.to ? {
                            from: data.from,
                            to: data.to,
                        } : undefined,
                        allDates: !data.from && !data.to,
                    })),
                } : undefined,
            }
        }      
        case DataEntryActionConstants.saveSensitiveInfo: {
            let si = state.transactionDetails.sensitiveInfo;
            let newSI = action.data;
        
            for (var i = 0; i < si.length; i++) {
                let siID = si[i].id;
                const updatedSI = newSI.find(sirecord => sirecord.id === siID);
                if (updatedSI) {                
                    si[i] = updatedSI;
                }
            }

            return {               
                ...state, transactionDetails: { ...state.transactionDetails, si }
            }
        }
        case DataEntryActionConstants.getWaitAndHoldReasonsSuccess:
            return {
                ...state,
                transactionWaitAndHoldReasons: generatePickerOptionsNoDefault(action.data, "name", "waitHoldReasonID"),
                transactionWaitAndHoldReasonsAPISuccess: API_SUCCESS
            }
        case DataEntryActionConstants.getWaitAndHoldReasonsFailure:
            return {
                ...state,
                transactionWaitAndHoldReasonsAPIFailure: API_FAILURE
            }
        case DataEntryActionConstants.postWaitAndHoldReasonsSuccess:
            return {
                ...state,
                postWaitAndHoldReasonsAPIStatus: API_SUCCESS
            }
        case DataEntryActionConstants.postWaitAndHoldReasonsRequest:
            return {
                ...state,
                postWaitAndHoldReasonsAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.patchTransactionContinueRequest:
            return {
                ...state,
                patchTransactionContinueAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.patchTransactionContinueSuccess:
            return {
                ...state,
                patchTransactionContinueAPIStatus: API_FETCHING
            }
        case DataEntryActionConstants.updateDeliveryInstructionsStatus:
            return {
                ...state,
                updateDeliveryInstructionsStatus: action.data
            }

        case DataEntryActionConstants.GET_QA_ERRORS_RESULTS:
            return {
                ...state,
                getQAErrorsStatus: API_FETCHING
            }
        case DataEntryActionConstants.GET_QA_ERRORS_RESULTS_SUCCESS:
            return {
                ...state,
                getQAErrorsStatus: API_SUCCESS,
                getQAErrors: action.data

            }
        case DataEntryActionConstants.GET_QA_ERRORS_RESULTS_FAILURE:
            return {
                ...state,
                getQAErrorsStatus: API_FAILURE
            }
        case DataEntryActionConstants.GET_QA_ISSUES_RESULTS:
            return {
                ...state,
                getQAIssuesStatus: API_FETCHING
            }
        case DataEntryActionConstants.GET_QA_ISSUES_RESULTS_SUCCESS:
            return {
                ...state,
                getQAIssuesStatus: API_SUCCESS,
                getQAIssues: action.data
            }
        case DataEntryActionConstants.GET_QA_ISSUES_RESULTS_FAILURE:
            return {
                ...state,
                getQAIssuesStatus: API_FAILURE
            }
        case DataEntryActionConstants.getAuditUsersRequest:
            return {
                ...state,
                getAuditUsersStatus: API_FETCHING,
            }
        case DataEntryActionConstants.getAuditUsersSuccess:
            return {
                ...state,
                getAuditUsersStatus: API_SUCCESS,
                auditUsers: action.data
            }
        case DataEntryActionConstants.getAuditUsersFailure:
            return {
                ...state,
                getAuditUsersStatus: API_FAILURE,
            }
        case DataEntryActionConstants.GET_SENSITIVITY_TYPES_RESULTS:
            return {
                ...state,
                getSensitivityTypesStatus: API_FETCHING
            }
        case DataEntryActionConstants.GET_SENSITIVITY_TYPES_RESULTS_SUCCESS:
            return {
                ...state,
                getSensitivityTypesStatus: API_SUCCESS,
                getSensitivityTypes: action.data
            }
        case DataEntryActionConstants.GET_SENSITIVITY_TYPES_RESULTS_FAILURE:
            return {
                ...state,
                getSensitivityTypesStatus: API_FAILURE
            }
        case DataEntryActionConstants.resolveQATransactionIssueRequest:
            return {
                ...state,
                resolveQAIssueStatus: API_FETCHING,
            }
        case DataEntryActionConstants.resolveQATransactionIssueSuccess:
            return {
                ...state,
                resolveQAIssueStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.resolveQATransactionIssueFailure:
            return {
                ...state,
                resolveQAIssueStatus: API_FAILURE,
            }
        case DataEntryActionConstants.removeQATransactionIssueRequest:
            return {
                ...state,
                removeQAIssueStatus: API_FETCHING,
            }
        case DataEntryActionConstants.removeQATransactionIssueSuccess:
            return {
                ...state,
                removeQAIssueStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.removeQATransactionIssueFailure:
            return {
                ...state,
                removeQAIssueStatus: API_FAILURE,
            }
        case DataEntryActionConstants.disputeIssueRequest:
            return {
                ...state,
                disputeIssueStatus: API_FETCHING,
            }
        case DataEntryActionConstants.disputeIssueSuccess:
            return {
                ...state,
                disputeIssueStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.disputeIssueFailure:
            return {
                ...state,
                disputeIssueStatus: API_FAILURE,
            }
        case DataEntryActionConstants.upholdIssueRequest:
            return {
                ...state,
                upholdIssueStatus: API_FETCHING,
            }
        case DataEntryActionConstants.upholdIssueSuccess:
            return {
                ...state,
                upholdIssueStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.upholdIssueFailure:
            return {
                ...state,
                upholdIssueStatus: API_FAILURE,
            }
        case DataEntryActionConstants.GET_QA_PD_ISSUES_RESULTS:
            return {
                ...state,
                getQAPDIssuesStatus: API_FETCHING
            }
        case DataEntryActionConstants.GET_QA_PD_ISSUES_RESULTS_SUCCESS:
            return {
                ...state,
                getQAPDIssuesStatus: API_SUCCESS,
                qaPDIssues: action.data
            }
        case DataEntryActionConstants.GET_QA_PD_ISSUES_RESULTS_FAILURE:
            return {
                ...state,
                getQAPDIssuesStatus: API_FAILURE
            }
        case DataEntryActionConstants.postQATransactionIssueRequest:
            return {
                ...state,
                postQATransactionIssueAPIStatus: API_FETCHING,
                error: null
            }
        case DataEntryActionConstants.postQATransactionIssueSuccess:
            return {
                ...state,
                postQATransactionIssueAPIStatus: API_SUCCESS,
                payload: {
                    transactionID: action.transactionID,
                    qaErrorID: action.qaErrorID,
                    userID: global.userID,
                    pageNumber: action.pageNumber,
                    issueDetails: action.issueDetails,
                    fileName: action.fileName
                }
            }
        case DataEntryActionConstants.postQATransactionIssueFailure:
            return {
                ...state,
                postQATransactionIssueAPIStatus: API_FAILURE,
                error: {
                    transactionID: action.transactionID,
                    qaErrorID: action.qaErrorID,
                    userID: global.userID,
                    pageNumber: action.pageNumber,
                    issueDetails: action.issueDetails,
                    fileName: action.fileName
                }
            }

        case DataEntryActionConstants.updateClinicIDResponse: {
            const inst: any = state.discloseInstitutions.find((i: any) => i.id == action.data);
            const newInst = { ...inst };

            return {
                ...state,
                leftPaneTransactionDetails: {
                    ...state.leftPaneTransactionDetails,
                    disclosingInstitution: newInst
                },
                transactionDetails: state.transactionDetails ? {
                    ...state.transactionDetails,
                    disclosingInstitution: newInst,
                } : undefined,
            }
        }

        case DataEntryActionConstants.userInputUpdateDataEntryDetailRequestorContact:
            const requestorDetails: Requestor = (state.requestorDetails as Requestor | undefined) ?? {
                requestorID: 0,
                typeOfRequestorID: 0,
                fullName: "",
                eTransferSetup: "",
                notes: "",
                prePay: false,
                requestorAddress: new Address(),
            }
            const retItem = {
                ...state,
                requestorDetails: {
                    ...requestorDetails,
                    requestorInfo: {
                        ...requestorDetails.requestorInfo,
                        id: action.data.data.requestorcontactid
                    }
                }
            }

            if (action.data.data.firstname) {
                retItem.requestorDetails.requestorInfo['firstName'] = action.data.data.firstname
            }

            if (action.data.data.lastname) {
                retItem.requestorDetails.requestorInfo['lastName'] = action.data.data.lastname
            }

            if (action.data.data.email) {
                retItem.requestorDetails.requestorInfo['email'] = action.data.data.email
            }

            if (action.data.data.fax) {
                retItem.requestorDetails.requestorInfo['fax'] = action.data.data.fax
            }

            if (action.data.data.phone) {
                retItem.requestorDetails.requestorInfo['phone'] = action.data.data.phone
            }

            return retItem;
        case DataEntryActionConstants.REQUESTOR_COMPLETE_SAGA:
            return {
                ...state,
                requestorComplete: true
            }
        case DataEntryActionConstants.setConfirmFax:
            return {
                ...state,
                confirmFax: action.data
            }
        case DataEntryActionConstants.SET_PDF_PAGE_NUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber,
                currentFile: action.fileDesc
            }
        // AB#31605 (Quick Entry grounding highlight): a transient, on-click source-region
        // highlight for the located date fields. Kept SEPARATE from pageNumber so the
        // scroll-reset-on-scroll (setPageNumber(null,...)) never clears the highlight, and
        // so click-to-reveal on the grounding icon draws the box while the page-jump uses
        // the existing SET_PDF_PAGE_NUMBER seam. undefined = no active highlight.
        case DataEntryActionConstants.SET_GROUNDING_HIGHLIGHT:
            return {
                ...state,
                groundingHighlight: action.grounding
            }
        case DataEntryActionConstants.GET_AI_FEEDBACK_REQUEST:
            return {
                ...state,
                getAIFeedbackStatus: API_FETCHING,
            }
        case DataEntryActionConstants.GET_AI_FEEDBACK_SUCCESS:
            return {
                ...state,
                getAIFeedbackStatus: API_SUCCESS,
                aiFeedback: action.data
            }
        case DataEntryActionConstants.GET_AI_FEEDBACK_FAILURE:
            return {
                ...state,
                getAIFeedbackStatus: API_FAILURE,
            }
        case DataEntryActionConstants.SUBMIT_AI_FEEDBACK_REQUEST:
            return {
                ...state,
                submitAIFeedbackStatus: API_FETCHING,
            }
        case DataEntryActionConstants.SUBMIT_AI_FEEDBACK_SUCCESS:
            return {
                ...state,
                submitAIFeedbackStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.SUBMIT_AI_FEEDBACK_FAILURE:
            return {
                ...state,
                submitAIFeedbackStatus: API_FAILURE,
            }
        case DataEntryActionConstants.DELETE_AI_FEEDBACK_REQUEST:
            return {
                ...state,
                deleteAIFeedbackStatus: API_FETCHING,
            }
        case DataEntryActionConstants.DELETE_AI_FEEDBACK_SUCCESS:
            return {
                ...state,
                deleteAIFeedbackStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.DELETE_AI_FEEDBACK_FAILURE:
            return {
                ...state,
                deleteAIFeedbackStatus: API_FAILURE,
            }
        case DataEntryActionConstants.SUBMIT_AI_FEEDBACK_BULK_REQUEST:
            return {
                ...state,
                submitAIFeedbackBulkStatus: API_FETCHING,
            }
        case DataEntryActionConstants.SUBMIT_AI_FEEDBACK_BULK_SUCCESS:
            return {
                ...state,
                submitAIFeedbackBulkStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.SUBMIT_AI_FEEDBACK_BULK_FAILURE:
            return {
                ...state,
                submitAIFeedbackBulkStatus: API_FAILURE,
            }
        case DataEntryActionConstants.UNDO_AI_FEEDBACK_BULK_REQUEST:
            return {
                ...state,
                undoAIFeedbackBulkAPI: API_FETCHING,
            }
        case DataEntryActionConstants.UNDO_AI_FEEDBACK_BULK_SUCCESS:
            return {
                ...state,
                undoAIFeedbackBulkAPI: API_SUCCESS,
            }
        case DataEntryActionConstants.UNDO_AI_FEEDBACK_BULK_FAILURE:
            return {
                ...state,
                undoAIFeedbackBulkAPI: API_FAILURE,
            }
        case DataEntryActionConstants.SET_CURRENT_FILE_TYPE:
            return {
                ...state,
                currentFileType: action.fileType,
            }
        case DataEntryActionConstants.getCertificationTypesRequest:
            return {
                ...state,
                getCertificationTypesStatus: API_FETCHING,
            }
        case DataEntryActionConstants.getCertificationTypesFailure:
            return {
                ...state,
                getCertificationTypesStatus: API_FAILURE,
            }
        case DataEntryActionConstants.getCertificationTypesSuccess:
            return {
                ...state,
                getCertificationTypesStatus: API_SUCCESS,
                certificationTypes: action.data,
            }
        case DataEntryActionConstants.setCertificationTemplateRequest:
            return {
                ...state,
                setCertificationTemplateStatus: API_FETCHING,
            }
        case DataEntryActionConstants.setCertificationTemplateSuccess:
            return {
                ...state,
                setCertificationTemplateStatus: API_SUCCESS,
            }
        case DataEntryActionConstants.setCertificationTemplateFailure:
            return {
                ...state,
                setCertificationTemplateStatus: API_FAILURE,
            }
        case DataEntryActionConstants.updateReplaceDocumentRequest:
            return {
                ...state,
                updateReplaceDocumentStatus: API_FETCHING
            }
        case DataEntryActionConstants.updateReplaceDocumentSuccess:
            return {
                ...state,
                updateReplaceDocumentStatus: API_SUCCESS
            }
        case DataEntryActionConstants.updateReplaceDocumentFailure:
            return {
                ...state,
                updateReplaceDocumentStatus: API_FAILURE
            }
        case DataEntryActionConstants.getCompleteStatusCheckRequest:
            return {
                ...state,
                getCompleteStatusCheckStatus: API_FETCHING
            }
        case DataEntryActionConstants.getCompleteStatusCheckSuccess:
            return {
                ...state,
                getCompleteStatusCheckStatus: API_SUCCESS,
                completeStatusCheck: action.data
            }
        case DataEntryActionConstants.getCompleteStatusCheckFailure:
            return {
                ...state,
                getCompleteStatusCheckStatus: API_FAILURE
            }
        case DataEntryActionConstants.getFeeSchedulesCheckRequest:
            return {
                ...state,
                getFeeSchedulesCheckStatus: API_FETCHING
            }
        case DataEntryActionConstants.getFeeSchedulesCheckSuccess:
            return {
                ...state,
                getFeeSchedulesCheckStatus: API_SUCCESS,
                feeSchedulesCheck: action.data
            }
        case DataEntryActionConstants.getFeeSchedulesCheckFailure:
            return {
                ...state,
                getFeeSchedulesCheckStatus: API_FAILURE
            }
        case DataEntryActionConstants.resetCompleteStatusCheck:
            return {
                ...state,
                completeStatusCheck: {}
            }
        case DataEntryActionConstants.resetFeeScheduleCheck:
            return {
                ...state,
                feeSchedulesCheck: undefined
            }
        case DataEntryActionConstants.putTransactionLockSuccess:
            return {
                ...state,
            }
        case DataEntryActionConstants.getFacilityConfigurationRequest:
            return {
                ...state,
                getFacilityConfigurationStatus: API_FETCHING
            }
        case DataEntryActionConstants.getFacilityConfigurationSuccess:  
            return {
                ...state,
                getFacilityConfigurationStatus: API_SUCCESS,
                facilityConfiguration: action.data
            }
        // Spec #34102 (F1d), AC11/AC12: the only writer of classicModeOverride.
        // One-way by construction - nothing ever sets it back to false.
        case DataEntryActionConstants.setClassicModeOverride:
            return {
                ...state,
                classicModeOverride: action.data,
            }
        case DataEntryActionConstants.getFacilityConfigurationFailure:
            return {
                ...state,   
                getFacilityConfigurationStatus: API_FAILURE,
                facilityConfiguration: undefined
            }
        default:
            // Delegating reducer for the Intake Intelligence slice, extracted
            // to IntakeDucks.ts (Spec #34098 / F1a, AC17, tidy-first #5).
            // Returns `state` unchanged for any action type it doesn't own.
            return intakeDucksReducer(state, action)
    }
}

function compare(a, b) {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
}

function compareIndividuals(a, b) {
    let la = a.name.split(",")[0];
    let lb = b.name.split(",")[0];
    if (la < lb) {
        return -1;
    }
    if (la > lb) {
        return 1;
    }
    return 0;
}

// create action creators here
export const updateShowAPIErrorActionCreator = (id) => {
    return {
        type: DataEntryActionConstants.HIDE_API_ERROR_MESSAGE,
        data: id
    }
}

export const updateShowPopupErrorActionCreator = (data) => {
    return {
        type: DataEntryActionConstants.HIDE_POPUP_ERROR_MESSAGE,
        data
    }
}

export const updateUserTasksActionCreator = (data) => {
    return {
        type: DataEntryActionConstants.updateUserTasksList,
        data
    }
}

export const updateUserTaskCommentsActionCreator = (data) => {
    return {
        type: DataEntryActionConstants.updateUserTaskComments,
        data
    }
}

export const getAssessmentResultsActionCreator = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.GET_ASSESSMENT_RESULTS,
        transactionId
    }
}

export const getReviewEntitiesActionCreator = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.GET_REVIEW_ENTITIES,
        transactionId
    }
}

export const getUserTasksActionCreator = (data) => {
    return {
        type: DataEntryActionConstants.getUserTasksRequest,
        data
    }
}

export const updateFormSyncErrorsActionCreator = (data) => {
    return {
        type: DataEntryActionConstants.updateFormSyncErrors,
        data
    }
}

export const billToRequestorDetailsActionCreator = (data) => {
    return {
        type: DataEntryActionConstants.getRequestorBillingDetails,
        data
    }
}

export const createPatientRecordRequest = (data, onSuccess, onError?) => {
    return {
        type: DataEntryActionConstants.createPatientRecordRequest,
        data,
        onSuccess,
        onError
    }
}

export const getPHICodesRequest = (data) => {
    return {
        type: DataEntryActionConstants.getPHICodesRequest,
        data
    }
}

export const setNextTransactionNullActionCreator = () => {
    return {
        type: DataEntryActionConstants.SET_NEXT_TRANSACTION_NULL
    }
}

export const setLastUsedRequestorInfo = (requestorInfo) => {
    return {
        type: DataEntryActionConstants.SET_LAST_USED_REQUESTOR,
        data: requestorInfo
    }
}

export const resetDataEntryState = () => {
    return {
        type: DataEntryActionConstants.resetState
    }
}

export const uploadDocument = (data: any) => {
    return {
        type: DataEntryActionConstants.uploadDocumentRequest,
        data
    }
}
export const postCancellationReasonsActionCreators = (transactionId: string, id: any, cancelReasonText: string = '', isDuplicate: boolean = false) => {
    return {
        type: DataEntryActionConstants.postCancellationReasonsRequest,
        transactionId,
        id,
        isDuplicate,
        cancelReasonText
    }
}

export const postQATransactionIssueActionCreators = (organizationId: number, requestBufferId: number, errorId: number, details: string, filename: string, madeBy: number, pageNumber?: number, editIssueId?: string) => {
    return {
        type: DataEntryActionConstants.postQATransactionIssueRequest,
        transactionID: organizationId + "-" + requestBufferId,
        organizationId,
        requestBufferId,
        errorId,
        pageNumber,
        details,
        filename,
        madeBy,
        id: editIssueId,
    }
}

export const resolveQATransactionIssueActionCreator = (transactionId: string, issueId: string) => {
    return {
        type: DataEntryActionConstants.resolveQATransactionIssueRequest,
        transactionId,
        issueId,
    };
}

export const removeQATransactionIssueActionCreator = (transactionId: string, issueId: string) => {
    return {
        type: DataEntryActionConstants.removeQATransactionIssueRequest,
        transactionId,
        issueId,
    };
}

export const disputeIssueActionCreator = (issueId: string, reason: string, transactionId: string) => {
    return {
        type: DataEntryActionConstants.disputeIssueRequest,
        data: {
            issueId,
            reason,
        },
        transactionId,
    }
}

export const upholdIssueActionCreator = (issueId: string, reason: string, transactionId: string) => {
    return {
        type: DataEntryActionConstants.upholdIssueRequest,
        data: {
            issueId,
            reason,
        },
        transactionId,
    }
}

export const getDoucmentSourcesActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.getDocumentSourcesRequest,
        data
    }
}


export const deleteDocumentActionCreator = (doctype: string, data: any) => {
    return {
        type: DataEntryActionConstants.deleteDocument,
        doctype,
        data
    }
}

export const getRejectionLetterActionCreator = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getRejectionLetterSagas,
        data: transactionId
    }
}

export const getPreviousTransactionActionCreator = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getPreviousTransactionSagas,
        data: transactionId
    }
}

export const getQAErrorsActionCreator = () => {
    return {
        type: DataEntryActionConstants.GET_QA_ERRORS_RESULTS,
    }
}

export const getQAIssuesActionCreator = (transactionID: string) => {
    return {
        type: DataEntryActionConstants.GET_QA_ISSUES_RESULTS,
        transactionID
    }
}

export const getQAPDIssuesActionCreator = (transactionID: string) => {
    return {
        type: DataEntryActionConstants.GET_QA_PD_ISSUES_RESULTS,
        transactionID
    }
}

export const getAuditUsersActionCreator = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getAuditUsersRequest,
        transactionId,
    }
}

export const getSensitivityTypesActionCreator = () => {
    return {
        type: DataEntryActionConstants.GET_SENSITIVITY_TYPES_RESULTS
    }
}

export const createQAReviewEntityCreator = (reviewEntity: qaReviewEntityProps) => {
    return {
        type: DataEntryActionConstants.createAIReviewEntityRequest,
        reviewEntity
    }
}

export const getRejectOptions = (facilityId: number) => {
    return {
        type: DataEntryActionConstants.getRejectOptionsRequest,
        data: facilityId,
    }
}

export const onChangeDataEntryTab = (data: number, tabClick: boolean) => {
    return {
        type: DataEntryActionConstants.onChangeTab,
        data,
        tabClick
    }
}

export const getRequestTypesAndPurposesRequest = (healthSystemId: Number) => {
    return {
        type: DataEntryActionConstants.getRequestTypesAndPurposesRequest,
        data: healthSystemId
    }
}


export const updateBillToRequestorDetailsRequest = (data: any, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.updateBillToRequestorRequest,
        data,
        onSuccess,
        onError,
    }
}
/**
 * Bug fix (2026-07-29): onSuccess is new and optional - every pre-existing call
 * site (the queue-reopen componentDidMount fetch, and the several sagas that
 * incidentally re-trigger this fetch as a side effect - e.g.
 * updateBillingPaneFieldsSaga) omits it and is unaffected. It exists so the
 * Quick-Entry-to-Classic hand-off (onQuickEntryCreateAndContinueToRecordAttachment
 * / onConfirmLeaveQuickEntry) can react to ITS OWN specific call completing,
 * rather than to transactionDetails changing reference for ANY reason - this
 * same action gets dispatched from multiple unrelated places during Quick
 * Entry's Confirm-All/billing-completion flow, so watching for "any change"
 * raced against those earlier, incidental calls and could flip the mode
 * switch before the hand-off's OWN fetch (with the now-linked patient) had
 * actually landed - reproducing the DOB-blocks-Requestor-tab bug this was
 * meant to fix.
 */
export const getTransactionAttributesActionCreator = (transactionId: string, onSuccess?: () => void) => {
    return {
        type: DataEntryActionConstants.GET_TRANSACTIONS_ATTRIBUTES_SAGA,
        data: transactionId,
        onSuccess,
    }
}


export const getDocumentByIdActionCreator = (documentId: string, auditOnShowDoc: boolean) => {
    return {
        type: DataEntryActionConstants.GET_DOCUMENT_BY_ID_SAGA,
        data: { documentId, auditOnShowDoc }
    }
}


export const getFacilityDiscloseInstitutionsRequest = (facilityId: number) => {
    return {
        type: DataEntryActionConstants.getFacilityDiscloseInstitutionsRequest,
        data: facilityId
    }
}

export const getFeeScheduleData = (facilityId: number, transactionId: string, setDefault: boolean) => {
    let details = { facilityId, transactionId, setDefault }
    return {
        type: DataEntryActionConstants.GET_FEE_SCHEDULE_DATA,
        data: details
    }
}

export const getReleaseMethodOptionsData = (facilityId: number, transactionId: string) => {
    let details = { facilityId, transactionId }
    return {
        type: DataEntryActionConstants.getReleaseMethodOptionsData,
        data: details
    }
}



export const updatePHIDisclosed = (transactionId: string, requestedItemID: string, isDelete: boolean) => {
    let PHIdetails = { transactionId, requestedItemID, isDelete }
    return {
        type: DataEntryActionConstants.UPDATE_PHI_DISCLOSED_SAGA,
        data: PHIdetails
    }
}

export const getShippingServicesData = (facilityId: number) => {
    return {
        type: DataEntryActionConstants.GET_SHIPPING_SERVICE_DATA,
        data: facilityId
    }
}

export const getTransactionNotesRequest = (data: any) => {
    return {
        type: DataEntryActionConstants.getTransactionNotesRequest,
        data
    }
}

export const getAdditionalChargeType = (data: any) => {
    return {
        type: DataEntryActionConstants.getAdditionalChargeType,
        data
    }
}

export const getAdditionalChargeRecordsCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.getAdditionalChargeRecords,
        data
    }
}
export const getRequestorSearchDetailsActionCreator = (data: any, facilityId: number, globalUserId: number) => {
    return {
        type: DataEntryActionConstants.getRequestorSearchDetailsSAGA,
        data,
        facilityId,
        globalUserId
    }
}
export const getContactSearchDetailsActionCreator = (requestorId: any, distinct?: boolean | undefined) => {
    return {
        type: DataEntryActionConstants.getContactSearchDetailsSAGA,
        requestorId,
        distinct
    }
}

export const updateDocumentActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.updateDocumentRequest,
        data
    }
}

export const batchUpdateDocumentsActionCreator = (data: DocumentUpdateRequests) => {
    return {
        type: DataEntryActionConstants.batchUpdateDocumentsRequest,
        data: data
    }
}

export const getFacilityConfigurationsActionCreator = (facilityId: number) : FacilityConfigurationSaga => {
    return {
        type: DataEntryActionConstants.getFacilityConfigurationRequest,
        data: facilityId
    }
}

// getIntakeIntelligenceActionCreator / requestIntakeIntelligenceActionCreator
// moved to IntakeDucks.ts (Spec #34098 / F1a, AC17, tidy-first #5) - imported
// above and re-exported below for any other existing import sites.

function updatePatientDetailsForTransaction(transactionDetails: TransactionDetails, patientId: number): TransactionDetails {
    return {
        ...transactionDetails,
        patient: {
            name: transactionDetails.patient?.name ?? "",
            id: patientId,
        }
    };
}

/**
 * @deprecated very type-unsafe
 */
const updateTransactionDetails = (localState: any, details: any) => {
    let updatedTransactionDetails = localState.leftPaneTransactionDetails || {}
    updatedTransactionDetails = {
        ...updatedTransactionDetails,
        ...details,
        date: {
            ...updatedTransactionDetails.date,
            ...details
        }
    }
    return updatedTransactionDetails
}

/**
 * @deprecated
 */
const updateRequestorDetails = (localState: any, details: any) => {
    let updatedRequestorDetails: Requestor = (localState.requestorDetails as Requestor | undefined) ?? {
        requestorID: 0,
        typeOfRequestorID: 0,
        prePay: false,
        notes: "",
        fullName: "",
        eTransferSetup: "",
        requestorAddress: new Address(),
    }
    updatedRequestorDetails = {
        ...updatedRequestorDetails,
        requestorAddress: {
            ...updatedRequestorDetails.requestorAddress,
            ...details
        },
        requestorInfo: {
            ...updatedRequestorDetails.requestorInfo,
            ...details
        },
        ...details
    }
    return updatedRequestorDetails
}

const updatePatientDetails = (localState, details: any) => {
    let updatedPatientDetails = localState.leftPanePatientDetailsAttributes
    updatedPatientDetails = {
        ...updatedPatientDetails,
        ...details,
        contact: {
            ...updatedPatientDetails.contact,
            ...details
        }
    }
    return updatedPatientDetails
}

const updatePatientDetailsRightPane = (localState, details: any) => {
    let updatedPatientDetails = localState.rightPaneUpdatedPatientDetailsAttributes
    updatedPatientDetails = {
        ...updatedPatientDetails,
        ...details,
        contact: {
            ...updatedPatientDetails.contact,
            ...details
        }
    }
    return updatedPatientDetails
}

/**
 * @deprecated replaced by createSendToContactActionCreator
 */
export const sendToContactDataActionCreator = (requestContactData: sendToContactDataProps) => {
    return {
        type: DataEntryActionConstants.SEND_TO_REQUESTOR_CONTACT_DATA_SAGA,
        data: requestContactData
    }
}

export function createSendToContactActionCreator(data: NewSendToContact) {
    return {
        type: DataEntryActionConstants.createSendToContact,
        data,
    }
}

export function updateSendToContactActionCreator(organizationId: number, requestBufferId: number, contact: Contact) {
    return {
        type: DataEntryActionConstants.updateSendToContact,
        data: {
            organizationId,
            requestBufferId,
            contactId: contact.id,
        } as SendToContactUpdate,
        contact,
    }
}

export const getTransactionDocuments = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getTransactionDocumentsRequest,
        data: transactionId
    }
}

export const patchPatientNoteActionCreators = (patientid: any, note: any, globalUserID: any, transactionId: any) => {
    return {
        type: DataEntryActionConstants.patchPatientsNotesSagas,
        data: { patientid, note, globalUserID, transactionId }
    }
}

export const patchRequestorNoteActionCreators = (requestorid: any, note: any, globalUserID: any, contactId: any) => {
    return {
        type: DataEntryActionConstants.patchRequestorsNotesSagas,
        data: { requestorid, note, globalUserID, contactId }
    }
}

export const patchSendToRequestorContactActionCreators = (requestData: sendToRequestorDataProps) => {
    return {
        type: DataEntryActionConstants.patchSendToRequestorContactSagas,
        data: requestData
    }
}

/**
 * @deprecated not type safe
 */
export const updateRequestorContactInfo = (data: any) => {
    return {
        type: DataEntryActionConstants.userInputUpdateDataEntryDetailRequestorContact,
        data: data
    }
}

export const getTransactionNoteTypes = (facilityId: number) => {
    return {
        type: DataEntryActionConstants.getTransactionNoteTypesRequest,
        data: facilityId
    }
}

export const getCancellationReasons = (facilityId: number) => {
    return {
        type: DataEntryActionConstants.getCancellationReasons,
        data: facilityId
    }
}

export const updateTransactionNotes = (data: any) => {
    return {
        type: DataEntryActionConstants.updateTransactionNotes,
        data
    }
}

export const updateAdditionalChargesActionCreator = (requestData: updateAdditionalChargesProps, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.UPDATE_ADDITIONAL_CHARGES_SAGA,
        data: requestData,
        onSuccess,
        onError,
    }
}

export interface UploadDocumentAction {
    readonly type: typeof DataEntryActionConstants.uploadMultipleDocumentsRequest;
    readonly data: DocumentUploadRequest;
}

/**
 * Uploads a _single_ document.
 * @param data
 */
export function uploadMultipleDocumentsActionCreator(data: DocumentUploadRequest): UploadDocumentAction {
    return {
        type: DataEntryActionConstants.uploadMultipleDocumentsRequest,
        data,
    }
}

export const getRetrieveProtocolActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.getRetrieveProtocolRequest,
        data
    }
}

export const getSelectedPHICodesActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.GET_SELECTED_PHI_CODES_SAGA,
        data
    }
}

export const rejectionContactOverrideActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.rejectionContactOverrideRequest,
        data
    }
}

/**
 * Bug fix (Spec #34102 / F1d, direct user report): onSuccess/onError are
 * new, optional, and default to undefined - every pre-existing call site
 * (Classic Mode's per-field billing autosave) omits them and is completely
 * unaffected. Added so Quick Entry's bulk Billing save can actually wait
 * for this to land before firing the completion signal (persistQuickEntryBillingFields
 * in DataEntryDetails.tsx), instead of firing both as an unordered,
 * unchecked fire-and-forget pair.
 */
export const updateBillingPaneFields = (data: any, updateData?: boolean, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.updateBillingPaneFields,
        data,
        updateData,
        onSuccess,
        onError,
    }
}

/**
 * Spec #34102 (F1d), AC11/AC12: sets the one-way Classic-Mode-exit override.
 * Only ever called with `true` (from LeaveQuickEntryModal's confirm) -
 * there is deliberately no corresponding "unset" call site.
 */
export const setClassicModeOverrideActionCreator = (value: boolean) => {
    return {
        type: DataEntryActionConstants.setClassicModeOverride,
        data: value,
    }
}

export const nextTransactionIdActionCreator = (facilityId: number, context: number = 1) => {
    return {
        type: DataEntryActionConstants.GET_NEXT_TRANSACTION_REQUEST_SAGA,
        data: { facilityId, context },
    }
}

export const getPatientSearchDetailsActionCreator = (facilityId: number, lastName: any, dob: any) => {
    return {
        type: DataEntryActionConstants.GET_PATIENT_SEARCH_DETAILS_SAGA,
        data: { facilityId, lastName, dob }
    }
}

export const postRejectionDetailsActionCreator = (rejection: Rejection) => {
    return {
        type: DataEntryActionConstants.POST_REJECTION_ACTION_SAGA,
        data: rejection
    }
}

export const setPDFPageNumberActionCreator = (pageNumber: number, fileDesc: string) => {
    return {
        type: DataEntryActionConstants.SET_PDF_PAGE_NUMBER,
        pageNumber,
        fileDesc
    }
}

// AB#31605 (Quick Entry grounding highlight): set (or clear, with undefined) the
// on-click source-region highlight the PdfViewer draws for a located field.
export const setGroundingHighlightActionCreator = (grounding?: FieldGrounding) => {
    return {
        type: DataEntryActionConstants.SET_GROUNDING_HIGHLIGHT,
        grounding
    }
}

export const getUserGroupsActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.getUserGroupsRequest,
        data
    }
}

export const getDisclosureReasonActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.GET_DISCLOSURE_REASON_SAGA,
        data
    }
}

/**
 * Spec #35135: onSuccess/onError are new, optional, and default to undefined -
 * Classic's own call site (DataEntryDetailsRightPane's blur handler) omits them
 * and is completely unaffected. Added so Quick Entry's Confirm-All persist gate
 * can represent this write as a Promise<boolean> that resolves true/false and
 * never rejects, matching every other write in that gate (see
 * updateBillingPaneFields's identical note above).
 */
export const updateDisclosureInformationActionCreator = (data: any, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.UPDATE_DISCLOSURE_INFORMATION_SAGA,
        data,
        onSuccess,
        onError,
    }
}

export const createUserTaskCommentActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.createUserTaskComment,
        data
    }
}

export const addNewTaskActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.addNewUserTaskRequest,
        data
    }
}

export const updateTaskActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.updateUserTask,
        data
    }
}

export const deleteTransactionTaskActionCreator = (transactionId: string, usertaskId: string) => {
    return {
        type: DataEntryActionConstants.DELETE_TRANSACTION_TASK_SAGA,
        data: { transactionId, usertaskId }
    }
}


export const saveInformationToReleaseActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.saveInformationToReleaseRequest,
        data
    }
}

/**
 * AB#37995: onSuccess/onError are new and optional - Classic's call sites pass neither and are
 * unaffected. Added so Quick Entry's Confirm-All gate can tell whether the POST actually landed
 * (see updateDisclosureInformationActionCreator's identical note).
 */
export function updateInformationToReleaseActionCreator(data: ReleaseInfoUpdate, onSuccess?: () => void, onError?: () => void) {
    return {
        type: DataEntryActionConstants.updateInformationToReleaseRequest,
        data,
        onSuccess,
        onError,
    }
}
export const saveSensitiveInfoActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.saveSensitiveInfoRequest,
        data
    }
}

export function updateSensitiveInfoActionCreator(data: SensitiveInfoUpdateAPI) {
    return {
        type: DataEntryActionConstants.saveAndUpdateSensitiveInfoRequest,
        data,
    }
}

/**
 * Spec #35135: onSuccess/onError are new, optional, and default to undefined -
 * every pre-existing call site (CompleteTransactionPopUp / DataEntryDetailsRightPane)
 * omits them and is unaffected. Quick Entry's Disclosure Accounting completion
 * needs to know when the finalize actually landed before it shows the
 * "Transaction created" card and schedules the auto-advance (AC9a).
 */
export const completeTransactionTaskActionCreator = (data: any, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.COMPLETE_TRANSACTION_REQUEST_SAGA,
        data,
        onSuccess,
        onError,
    }
}

export const returnToQueueTaskActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.RETURN_TO_QUEUE_SAGA,
        data
    }
}

export const createPatientRecordSuccess = (data) => {
    return {
        type: DataEntryActionConstants.createPatientRecordSuccess,
        data
    }
}

/**
 * AB#31605 (deadlock fix, round-1 review CRITICAL-4): onSuccess/onError are new,
 * optional, and default to undefined - Classic's own call site
 * (DataEntryDetailsRightPane's tab-leave) omits them and is unaffected. Quick Entry
 * needs to know when the audit write has LANDED so the type-66 finalize
 * (completeTransaction -> MoveToRPQ, which deletes the tblRequestBuffer row this
 * audit write targets) can run strictly after it instead of racing it.
 */
export const detailsCompleteActionCreator = (transactionId: string, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.DETAILS_COMPLETE_SAGA,
        data: { transactionId },
        onSuccess,
        onError,
    }
}

export const requestorCompleteActionCreator = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.REQUESTOR_COMPLETE_SAGA,
        data: { transactionId }
    }
}

/** Bug fix (Spec #34102 / F1d, direct user report): onSuccess/onError are new, optional, default undefined - every pre-existing call site (Classic Mode's own Billing-tab-navigation trigger) omits them and is unaffected. See updateBillingPaneFields's own comment above for why. */
export const billingCompleteActionCreator = (transactionId: string, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.BILLING_COMPLETE_SAGA,
        data: { transactionId },
        onSuccess,
        onError,
    }
}

export const patchPatientDetailsCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.patchPatientDetails,
        data
    }
}

export const getAuditTypesRequest = (data: any) => {
    return {
        type: DataEntryActionConstants.getAuditTypesRequest,
        data
    }
}

export const getOBOsRequest = (data: any) => {
    return {
        type: DataEntryActionConstants.getOBOsRequest,
        data
    }
}

export const getValidateRequest = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getValidateRequest,
        data: { transactionId }
    }
}

export const getValidateSuccess = (data: any) => {
    return {
        type: DataEntryActionConstants.getValidateSuccess,
        data
    }
}

export const getValidateFailure = (data: any) => {
    return {
        type: DataEntryActionConstants.getValidateFailure,
        data
    }
}
// requestor verification notifcation
export const requestorVerificationEmailSent = () => {
    return {
        type: DataEntryActionConstants.requestorVerificationEmailSent,
    }
}

export const RequestorVerificationEmailSentReset = () => {
    return {
        type: DataEntryActionConstants.requestorVerificationEmailSentReset
    }
}

export const getAuditTrail = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getAuditTrailRequest,
        data: { transactionId }
    }
}

export const checkDuplicateTransactions = (transactionId: string, caseNumber: string) => {
    return {
        type: DataEntryActionConstants.GET_DUPLICATE_TRANSACTIONS,
        data: {
            transactionId,
            caseNumber
        }
    }
}

export const ShowDuplicateTransactions = (data: any) => {
    return {
        type: DataEntryActionConstants.SHOW_DUPLICATE_TRANSACTIONS,
        data
    }
}

export const hideDuplicateTransactionsPopup = () => {
    return {
        type: DataEntryActionConstants.HIDE_DUPLICATE_TRANSACTIONS,
        data: null
    }
}

export const getTransactionDocumentsToCopy = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getTransactionDocumentsToCopyRequest,
        data: transactionId
    }
}

export const resetTransactionDocumentsToCopy = () => {
    return {
        type: DataEntryActionConstants.resetTransactionDocumentsToCopyRequest
    }
}
export const updateTransactionOnFileCreater = (data: any) => {
    return {
        type: DataEntryActionConstants.updateTransactionOnFileRequest,
        data
    }
}

export const postWPSToken = (transactionId: string, docType: string) => {
    return {
        type: DataEntryActionConstants.postWPSRequest,
        data: { transactionId, docType }
    }
}

export const clearPreviousTransactionOnCompleteCreator = () => {
    return {
        type: DataEntryActionConstants.clearPreviousTransactionOnComplete
    }
}

export const readBarCodeDDSRequest = (documentId: string) => {
    return {
        type: DataEntryActionConstants.readBarCodeDDSRequest,
        data: documentId
    }
}

export const readBarCodeDDSSuccess = (data: any) => {
    return {
        type: DataEntryActionConstants.readBarCodeDDSSuccess,
        data: data
    }
}

export const readBarCodeDDSFailure = () => {
    return {
        type: DataEntryActionConstants.readBarCodeDDSFailure
    }
}

/**
 * Alters the requestor data in the data entry state without any API calls.
 * @deprecated Not type-safe, use `setRequestorDetailsActionCreator` instead
 */
export const updateRequestorDetailsAction = (data: any) => {
    return {
        type: DataEntryActionConstants.updateRequestorDetails,
        data: data
    }
}

/**
 * Sets the `requestorDetails` in the data entry state without any API calls.
 * @param requestor Requestor data to use.
 * @returns Redux action
 */
export function setRequestorDetailsActionCreator(requestor?: Requestor) {
    return {
        type: DataEntryActionConstants.setRequestorDetails,
        requestor,
    }
}

/**
 * Sets the `requestorDetails.requestorInfo` in the data entry state without any API calls.
 * @param contact Contact data to use.
 * @returns Redux action.
 */
export function setSendToContactActionCreator(contact?: Contact) {
    return {
        type: DataEntryActionConstants.setRequestorContact,
        contact,
    }
}

/**
 * AB#38349: sets `transactionDetails.releaseMethod` from a release-method id, without any API
 * call - the same put() `patchSendToRequestorContactSaga` / `updateSendToContactSaga` already make
 * when the server returns a re-evaluated `releaseMode`. Exposed as a creator so the Quick Entry
 * contact save, which PATCHes that endpoint directly rather than through the saga, can apply the
 * identical update instead of waiting for a later getTransactionAttributes to reconcile it.
 *
 * Callers must check the id against the loaded `releaseMethod` options first: the reducer writes
 * `find(x => x.id == data)` unconditionally, so an unknown id blanks the value.
 * @param releaseMethodId Release method id as the server returns it (`releaseMode`).
 * @returns Redux action.
 */
export function setReleaseMethodActionCreator(releaseMethodId: number) {
    return {
        type: DataEntryActionConstants.setReleaseMethod,
        data: releaseMethodId,
    }
}

export const getFacilityAdditionalFieldsActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.getFacilityAdditionalFieldsRequest,
        data: data
    }
}

export const getFacilityAdditionalFieldsFailure = (data: any) => {
    return {
        type: DataEntryActionConstants.getFacilityAdditionalFieldsFailure,
    }
}

export const getFacilitiesAdditionalFieldsSuccess = (data: any) => {
    return {
        type: DataEntryActionConstants.getFacilityAdditionalFieldsSuccess,
        data: data
    }
}

export const getWaitAndHoldReasons = (data: any) => {
    return {
        type: DataEntryActionConstants.getWaitAndHoldReasons,
        data: data
    }
}

export const postWaitAndHoldReasonsActionCreators = (transactionId: string, waitHoldReasons: any, statusIndicatorId: any, waitFor: string) => {
    return {
        type: DataEntryActionConstants.postWaitAndHoldReasonsRequest,
        transactionId,
        waitHoldReasons,
        statusIndicatorId,
        waitFor
    }
}

export const patchTransactionContinueActionCreator = (transactionId: string, waitHoldReasons: any) => {
    return {
        type: DataEntryActionConstants.patchTransactionContinueRequest,
        transactionId,
        waitHoldReasons
    }
}

export const putDigitalFaxValidationCreator = (transactionId: string, faxNumber: any, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.putDigitalFaxValidationRequest,
        transactionId,
        faxNumber,
        onSuccess,
        onError,
    }
}

export const putAuditTransactionSensitiveInfoCreator = (transactionId: string, recordContains: any) => {
    return {
        type: DataEntryActionConstants.putAuditTransactionSensitiveInfoRequest,
        transactionId,
        recordContains
    }
}

export const resetRequestorContactList = () => {
    return {
        type: DataEntryActionConstants.getContactSeacrhDetailsReset,
        data: []
    }
}

export const userViewedDocumentRequest = (documentId: string) => {
    return {
        type: DataEntryActionConstants.userViewedDocumentRequest,
        data: documentId
    }
}

export const setConfirmFaxNumberAction = (faxNumber: string) => {
    return {
        type: DataEntryActionConstants.setConfirmFax,
        data: faxNumber
    }
}

export const getAIFeedbackActionCreator = () => {
    return {
        type: DataEntryActionConstants.GET_AI_FEEDBACK_REQUEST,
    }
}

export const submitAIFeedbackActionCreator = (entityId: string, feedbackType: string) => {
    return {
        type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_REQUEST,
        entityId,
        feedbackType,
    }
}

export const deleteAIFeedbackActionCreator = (entityId: string) => {
    return {
        type: DataEntryActionConstants.DELETE_AI_FEEDBACK_REQUEST,
        entityId,
    }
}

export const submitAIFeedbackBulkActionCreator = (entityIds: string[], feedbackType: string) => {
    return {
        type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_BULK_REQUEST,
        payload: { entityIds, feedbackType}
    }
}

export const undoAIFeedbackBulkActionCreator = (entityIds: string[]) => {
    return {
        type: DataEntryActionConstants.UNDO_AI_FEEDBACK_BULK_REQUEST,
        payload: {entityIds},
    }
}

export const setCurrentFileTypeActionCreator = (fileType: string) => {
    return {
        type: DataEntryActionConstants.SET_CURRENT_FILE_TYPE,
        fileType,
    }
}
export const getCertificationTypesAction = () => {
    return {
        type: DataEntryActionConstants.getCertificationTypesRequest,
    }
}

export const setCertificationTemplateAction = (transactionId: string, certificationType: string, onSuccess?: () => void, onError?: () => void) => {
    return {
        type: DataEntryActionConstants.setCertificationTemplateRequest,
        transactionId,
        certificationType,
        onSuccess,
        onError,
    }
}

export const updateReplaceDocucmentActionCreator = (data: any) => {
    return {
        type: DataEntryActionConstants.updateReplaceDocumentRequest,
        data
    }
}

export const getCompleteStatusCheckAction = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getCompleteStatusCheckRequest,
        transactionId
    }
}

export const getFeeSchedulesCheckAction = (transactionId: string) => {
    return {
        type: DataEntryActionConstants.getFeeSchedulesCheckRequest,
        transactionId
    }
}

export const resetCompleteStatusCheckStateAction = () => {
    return {
        type: DataEntryActionConstants.resetCompleteStatusCheck
    }
}

export const resetFeeScheduleCheckStateAction = () => {
    return {
        type: DataEntryActionConstants.resetFeeScheduleCheck
    }
}

// setFeedbackForIntakeFieldActionCreator / IntakeFeedback moved to
// IntakeDucks.ts (Spec #34098 / F1a, AC17, tidy-first #5) - imported above
// and re-exported below.

// call wrapper function

function* callAPI<Fn extends (...args: any[]) => any>(fn: Fn, ...args: Parameters<Fn>) {
    let result = yield call(fn, ...args);
    let transactionID = args[0]?.data?.transactionId;
    if (result?.headers?.["refreshaudittrail"] === "1" && transactionID) {
        yield put({
            data: { transactionId: transactionID },
            type: DataEntryActionConstants.getAuditTrailRequest
        });
    }
    if (result?.headers?.["refreshstatusindicator"] === "1" && transactionID) {
        yield put({
            data: { transactionId: transactionID },
            type: DataEntryActionConstants.getStatusIndicatorRequest
        });
    }
    if (result?.data?.code === 1020 && result.data.message?.startsWith("Transaction in use by ")) {
        yield put({ type: LandingPageActionConstants.HEADER_ASSIGN_TRANSACTION_INFORMATION, data: result.data.message })
        yield put(push("/home"));
    }
    return result;
}

// create sagas here


export function* saveInformationToReleaseSaga(action: any) {
    try {
        let freeText = undefined;
        for (const item of action.data.recordTypes.filter(t => action.data.saveOnly.indexOf(t.id) > -1)) {
            const saveItem = {
                transactionId: action.data.transactionId,
                active: item.state ? 1 : 0,
                id: item.id,
                text: item.text,
                fromDate: action.data.fromDate === null ? "" : (<Date>action.data.fromDate).toJSON(),
                toDate: action.data.toDate === null ? "" : (<Date>action.data.toDate).toJSON(),
                auditable: action.data.auditable
            }

            if (item.id === OTHER_DOCUMENTS_RELEASE_ID)
                freeText = item.text;

            if ((saveItem.fromDate && saveItem.toDate) || (!saveItem.fromDate && !saveItem.toDate))
                yield callAPI(saveInformationToReleaseAPI, { data: saveItem })
        }

        const returnItem = action.data.recordTypes.map(t => ({
            allDates: action.data.allDates,
            checked: t.state,
            code: t.code,
            dateOfService: action.data.fromDate === null && action.data.toDate === null ? null : {
                model: "dateRange",
                from: action.data.fromDate === null ? "" : moment(action.data.fromDate).format("MM/DD/YYYY"),
                to: action.data.toDate === null ? "" : moment(action.data.toDate).format("MM/DD/YYYY"),
            },
            id: t.id,
            model: "releaseInfoItem",
            name: t.name,
            requestedItemID: t.id

        }))

        yield put({ type: DataEntryActionConstants.saveInformationToReleaseResponse, data: { returnItem, freeText: freeText } })

        //if(action.data.recordTypes.some(x => x.state === true)){
        //    yield put({ type: DataEntryActionConstants.GET_TRANSACTIONS_ATTRIBUTES_SAGA, data: action.data.transactionId })
        //}
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* updateInformationToReleaseSaga(action: { data: ReleaseInfoUpdate, onSuccess?: () => void, onError?: () => void }) {
    try {
        yield callAPI(updateInformationToReleaseApi, action.data);
        yield put({
            type: DataEntryActionConstants.saveInformationToRelease,
            data: action.data,
        });
        // AB#37995: axios rejects any non-2xx, so a server-side failure lands in the catch below -
        // which is where the Confirm-All gate learns the write did not land.
        action.onSuccess?.();
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
        action.onError?.();
    }
}


export function* saveAndUpdateSensitiveInfoSaga(action: { data: SensitiveInfoUpdateAPI }) {
    try {

        yield put({
            type: DataEntryActionConstants.saveSensitiveInfo,
            data: action.data.InfoList,
        });
        const response = yield callAPI(updateBillingPaneFieldsAPI, action.data.UpdatePayload);
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* updateUserTaskSaga(action: any) {
    try {
        yield callAPI(updateUserTaskAPI, action)
        yield put({ type: DataEntryActionConstants.getUserTasksRequest, data: action.data.transactionId })
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* addNewTaskSaga(action: any) {
    try {
        yield callAPI(adNewUserTaskAPI, action)
        yield put({ type: DataEntryActionConstants.getUserTasksRequest, data: action.data.transactionId })
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* createUserTaskCommentSagas(action: any) {
    try {
        yield callAPI(createUserTaskCommentAPI, action)
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* generateNextTransactionId(action: any) {
    try {
        let result = yield callAPI(generateNextTransactionIdAPI, { facilityId: action.data.facilityId, context: action.data.context });
        if (isSuccessStatusCode(result.status) && result.data.id) {
            if (result.data.isReadOnly) {
                yield put({ type: LandingPageActionConstants.SHOW_READONLY_TRANSACTION_REQUEST, data: result.data.id })
                yield put(push("/home"))
            } else {
                yield put({ type: DataEntryActionConstants.GET_NEXT_TRANSACTION_REQUEST, data: result.data.id })
                // AB#39020: derived from the returned transaction id, not action.data.facilityId -
                // on the org-level entry path that field is a health-system id, not a facility id.
                yield call(refreshSelectedFacilityCountsSaga, parseInt(String(result.data.id).split("-")[0], 10))
            }
        }
        else {
            yield put({ type: LandingPageActionConstants.HEADER_ASSIGN_TRANSACTION_INFORMATION, data: 'No next transaction available.' })
            yield call(clearUserLocksSaga, { data: global.userID })
            yield put(push("/home"))
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getAssessmentResultsSaga(action: any) {
    try {
        const response = yield callAPI(getAssessmentResultsAPI, action);
        yield put({ type: DataEntryActionConstants.GET_ASSESSMENT_RESULTS_SUCCESS, data: response.data })
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* getReviewEntitiesSaga(action: any) {
    try {
        const response = yield callAPI(getReviewEntitiesAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.GET_REVIEW_ENTITIES_SUCCESS, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.GET_REVIEW_ENTITIES_FAILURE, data: response.transactionId })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).message });
    }
}

export function* getRequestTypesAndPurposes(action: any) {
    try {
        const result = yield callAPI(getRequestTypes, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({
                type: DataEntryActionConstants.getRequestTypesAndPurposesSuccess,
                data: result.data,
            });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getRequestTypesAndPurposesFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })

    }

}

export function* getFacilityDiscloseInstitutions(action: any) {
    try {
        const result = yield callAPI(getDisclosingInstituionAPI, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.getFacilityDiscloseInstitutionsSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getFacilityDiscloseInstitutionsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* updatePHIdisclosedSaga(action: any) {
    try {
        yield callAPI(updatePHIdisclosedAPI, action)
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getDocumentByIdSaga(action: any) {
    try {
        const result = yield callAPI(getDocumentByIdAPI, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.getDocumentByIdSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getDocumentByIdFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).message })
    }
}

export function* deleteDocumentSaga(action: any) {
    try {
        let result;

        if (action.doctype === "MED" || action.doctype === "AUX") {
            result = yield callAPI(deleteDocumentByIdAPI, action)
        } else {
            throw new Error("This saga can only delete AUX and MED files")
        }

        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.deleteDocumentAPISuccess, data: result.data })
            yield put({ type: DataEntryActionConstants.deleteDocumentAPIInitial })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.deleteDocumentAPIFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getAdditionalChargeTypeList(action: any) {
    try {
        const result = yield callAPI(getAdditionalChargeTypeAPI, action)
        if (isSuccessStatusCode(result.status) && Array.isArray(result.data)) {
            yield put({ type: DataEntryActionConstants.getAdditionalChargeTypeSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getAdditionalChargeTypeFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getShippingServices(action: any) {
    try {
        const result = yield callAPI(getShippingServicesAPI, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.getShippingServicesSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getShippingServicesFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getCancellationReasonsSaga(action: any) {
    try {
        const result = yield callAPI(getCancellationReasonsAPI, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.getCancellationReasonsSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getCancellationReasonsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getSelectedPHICodesSaga(action: any) {
    try {
        const result = yield callAPI(getSelectedPHICodesAPI, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.getSelectedPHICodesSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getSelectedPHICodesFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })

    }

}

export function* getReleaseMethodOptions(action: any) {
    try {
        const result = yield callAPI(getReleaseMethodOptionsAPI, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.getReleaseMethodOptionsSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getReleaseMethodOptionsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getAdditionalChargeRecords(action: any) {
    try {
        const result = yield callAPI(getAdditionalChargeRecordsAPI, action)
        if (isSuccessStatusCode(result.status) && Array.isArray(result.data)) {
            yield put({ type: DataEntryActionConstants.getAdditionalChargeRecordsSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getAdditionalChargeRecordsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }

}

export function* getBillToRequestorDetailsSaga(action: any) {
    try {
        const billToRequestorDetails = yield callAPI(getRequestorBillingDetailsAPI, { requestorBillingId: action.data })
        yield put({ type: DataEntryActionConstants.getRequestorBillingDetailsSuccess, data: billToRequestorDetails.data })

    } catch (err) {
        yield put({ type: DataEntryActionConstants.getRequestorBillingDetailsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}



export function* getTransactionAttributes(action: any) {
    try {
        const transactionIdAttributesRes: AxiosResponse<TransactionDetails> = yield callAPI(getTransactionAttributesAPI, action)
        if (isSuccessStatusCode(transactionIdAttributesRes.status)) {
            let transactionId = transactionIdAttributesRes.data.facility?.id + '-' + transactionIdAttributesRes.data.id
            const requestObject = {
                facilityId: transactionIdAttributesRes.data.facility?.id.toString(),
                transactionId: transactionId.toString()
            }
            const releaseMethodData = yield callAPI(getReleaseMethodOptionsAPI, { data: requestObject })
            if (isSuccessStatusCode(releaseMethodData.status)) {
                yield put({ type: DataEntryActionConstants.getReleaseMethodOptionsSuccess, data: releaseMethodData.data })
            }
            if (transactionIdAttributesRes.data.requestPurpose) {
                yield put({ type: DataEntryActionConstants.GET_TRANSACTIONS_ATTRIBUTES, data: transactionIdAttributesRes.data.requestPurpose })
            }
            if (transactionIdAttributesRes.data.patient) {
                const patientDetails = yield callAPI(get, Api.getTransactionPatientAttributes + transactionIdAttributesRes.data.patient.id + "?userID=" + global.userID + "&transactionid=" + action.data)
                yield put({ type: DataEntryActionConstants.GET_TRANSACTIONS_PATIENT_ATTRIBUTES, data: patientDetails.data })
            }
            if (transactionIdAttributesRes.data.facility.useDepartments || transactionIdAttributesRes.data.facility.useClinics) {
                try {
                    const result = yield callAPI(getDisclosingInstituionAPI, { data: transactionIdAttributesRes.data.facility.id })
                    if (isSuccessStatusCode(result.status)) {
                        yield put({ type: DataEntryActionConstants.getFacilityDiscloseInstitutionsSuccess, data: result.data })
                    }
                } catch (err) {
                    yield put({ type: DataEntryActionConstants.getFacilityDiscloseInstitutionsFailure })
                    yield put({
                        type: LandingPageActionConstants.HEADER_ASSIGN_TRANSACTION_INFORMATION,
                        data: "There was an error retrieving the list of " + (transactionIdAttributesRes.data.facility.useDepartments ? "departments" : "clinics")
                    })
                }
            }
            yield put({ type: DataEntryActionConstants.getTransactionDetailsSuccess, data: transactionIdAttributesRes.data })
            if (transactionIdAttributesRes.data.sendToRequestor?.id) {
                const requestorDetails = yield callAPI(getRequestorDetailsAPI, {
                    requestorId: transactionIdAttributesRes.data.sendToRequestor.id,
                    requestorContactId: transactionIdAttributesRes.data.sendToContact?.id
                })
                yield put({ type: DataEntryActionConstants.getRequestorDetailsSuccess, data: requestorDetails.data })
                yield put({ type: DataEntryActionConstants.getContactDetailsSuccess, data: [] })
                yield put(getContactSearchDetailsActionCreator(transactionIdAttributesRes.data.sendToRequestor.id, true))
                const requestorContactDetails = yield callAPI(getContactDetailsAPI, { requestorId: transactionIdAttributesRes.data.sendToRequestor.id, distinct: true })
                yield put({ type: DataEntryActionConstants.getContactDetailsSuccess, data: requestorContactDetails.data })
            }
            if (transactionIdAttributesRes.data.billToContact?.id) {
                const billToRequestorDetails = yield callAPI(getRequestorBillingDetailsAPI, { requestorBillingId: transactionIdAttributesRes.data.billToContact?.id })
                yield put({ type: DataEntryActionConstants.getRequestorBillingDetailsSuccess, data: billToRequestorDetails.data })
            }
            if (transactionIdAttributesRes.data.lockedBy) {
                if (transactionIdAttributesRes.data.lockedBy.id != global.userID) {
                    yield put({
                        type: LandingPageActionConstants.HEADER_ASSIGN_TRANSACTION_INFORMATION,
                        data: `Transaction in use by ${transactionIdAttributesRes.data.lockedBy.displayName} and will be opened as read-only.`,
                    });
                }
            } else {
                yield callAPI(LockTransactionAPI, { transactionId: transactionId });
            }
            // Bug fix (2026-07-29): fires only after every dispatch above (incl.
            // GET_TRANSACTIONS_PATIENT_ATTRIBUTES) has landed, so a caller reacting
            // to this specifically knows the full fetch - not just some earlier,
            // unrelated dispatch of this same action - has completed.
            action.onSuccess?.();
        }
    } catch (err) {
        console.error(err);
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getFeeSchedules(action: any) {
    try {
        const feeSchedulesRes = yield callAPI(getFeeSchedulesAPI, action)
        if (isSuccessStatusCode(feeSchedulesRes.status)) {
            // AB#39575: guarded on still being ON this fetch's transaction, same precedent as
            // the upload-refresh guard above - feeSchedules is a single un-keyed slot, and a
            // fetch resolving after the specialist moved on would write the OLD transaction's
            // fee schedules into the slot for the new transaction to submit against.
            const currentTransactionId = yield select((state: any) => state.landingPageState.transactionId);
            if (currentTransactionId === action.data.transactionId) {
                yield put({ type: DataEntryActionConstants.GET_FEE_SCHEDULE_SUCCESS, data: feeSchedulesRes.data })
                if (action.data.setDefault) {
                    yield put(getTransactionAttributesActionCreator(action.data.transactionId))
                }
            }
        }
    } catch (err) {
        // Review round 2 (Nelson Omuto, AB#39575): this guard was on the success branch only -
        // an abandoned transaction's late failure dispatched getFeeScheduleFailure unconditionally,
        // wiping the CURRENTLY OPEN transaction's already-loaded list in the same un-keyed slot.
        // Same transaction-identity check as the success branch above.
        const currentTransactionId = yield select((state: any) => state.landingPageState.transactionId);
        if (currentTransactionId === action.data.transactionId) {
            yield put({ type: DataEntryActionConstants.getFeeScheduleFailure })
        }
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }
}

export function* getTransactionNotes(action: any) {
    try {
        const response = yield callAPI(getTransactionNotesAPI, action)
        if (isSuccessStatusCode(response.status) && Array.isArray(response.data)) {
            const sortedResults = sortDateObject(response.data, "created").reverse()
            yield put({ type: DataEntryActionConstants.getTransactionNotesSuccess, data: sortedResults })
        } else {
            yield put({ type: DataEntryActionConstants.getTransactionNotesFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

/**
 * @deprecated replaced by createSendToContactSaga
 */
export function* sendToRequestorContactData(action: any) {
    try {
        const response = yield callAPI(putSendToRequestorContactAPI, action)
        const requestObject = {
            transactionId: action.data.transactionID,
            userID: global.userID,
            sendToRequestorContactid: response.data.id
        }
        const updateedContactID = {
            data: {
                requestorcontactid: response.data.id
            }
        }
        yield put({ type: DataEntryActionConstants.userInputUpdateDataEntryDetailRequestorContact, data: updateedContactID })
        yield put({ type: DataEntryActionConstants.updateBillingPaneFields, data: requestObject, updateData: true })
        if (isSuccessStatusCode(response.status)) {
            if (response.data && response.data.isVerified) {
                yield put({ type: DataEntryActionConstants.requestorVerificationEmailSent })
            }
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* createSendToContactSaga(action: { data: NewSendToContact }) {
    try {
        const response: AxiosResponse<NewContactResponse> = yield callAPI(createSendToContactApi, action.data);

        const contact: Contact = {
            id: response.data.contactId,
            firstName: action.data.firstName,
            lastName: action.data.lastName,
            email: action.data.email,
            phone: action.data.phone,
            fax: action.data.fax,
            isVerified: response.data.isVerified,
        }
        yield put({
            type: DataEntryActionConstants.setRequestorContact,
            contact,
        })

        if (response.data.releaseMode) {
            yield put({
                type: DataEntryActionConstants.setReleaseMethod,
                data: response.data.releaseMode
            });
        }
    } catch (err) {
    const response = (err as any).response;
    const errors = response?.data?.errors;
    let errorMessage = 'An unknown error occurred.';
    
    if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
        const messages = Object.values(errors)
            .flat()
            .filter((msg): msg is string => typeof msg === 'string')
            .join(' ');
        
        if (messages.length > 0) {
            errorMessage = messages;
        }
    } else if (response?.data?.traceId) {
        errorMessage = `Trace ID: ${response.data.traceId} - An unknown error occurred.`;
    }
    
    if (response?.data) {
        response.data.message = errorMessage;
    }
    
    yield put({
        type: DataEntryActionConstants.API_ERROR_STATE,
        data: response
    });
}

}

export function* updateSendToContactSaga(action: { data: SendToContactUpdate, contact: Contact }) {
    try {
        const response: AxiosResponse<{ releaseMode?: number }> = yield callAPI(updateSendToContactApi, action.data);

        yield put({
            type: DataEntryActionConstants.setRequestorContact,
            contact: action.contact,
        });
        if (response.data.releaseMode) {
            yield put({
                type: DataEntryActionConstants.setReleaseMethod,
                data: response.data.releaseMode
            });
        }
    } catch (err) {
        if (err instanceof Object && "response" in err) {
            yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: err.response });
        }
    }
}

export function* updateBillToRequestorDetails(action: any) {
    // updateBillToContactDetailsAPI only issues a PATCH when requestorbillingcontactid
    // is present; with no id it returns undefined WITHOUT throwing. Track that so the
    // callback signals honestly - a no-op write must NOT report success (AB#35095
    // review HIGH-2; security.md §Error Handling silent-failure). Callers that pass no
    // onSuccess/onError (Classic's field-blur autosave) are unaffected.
    const patchIssued = !!action.data?.requestorbillingcontactid;
    try {
        yield callAPI(updateBillToContactDetailsAPI, action)
        if (Object.keys(action.data.data).indexOf("deliveryInstructions") > -1) {
            yield put({ type: DataEntryActionConstants.updateDeliveryInstructionsStatus, data: API_SUCCESS })
            yield put({ type: DataEntryActionConstants.updateDeliveryInstructionsStatus, data: API_INITIAL })
        }
        if (patchIssued) {
            action.onSuccess?.();
        } else {
            action.onError?.();
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        if (Object.keys(action.data.data).indexOf("deliveryInstructions") > -1) {
            yield put({ type: DataEntryActionConstants.updateDeliveryInstructionsStatus, data: API_FAILURE })
            yield put({ type: DataEntryActionConstants.updateDeliveryInstructionsStatus, data: API_INITIAL })
        }
        action.onError?.();
    }
}

export function* getRequestorSearchSaga(action: any) {
    try {
        const response = yield callAPI(getRequestorSearchDetailsAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getRequestorSearchDetailsSuccess, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.getRequestorSearchDetailsFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getPatientSearchSaga(action: any) {
    try {
        const response = yield callAPI(getPatientSearchDetailsAPI, action);
        if (isSuccessStatusCode(response.status)) {
            let patientInfo: any[] = [];
            for (let eachRow of response.data) {
                let customPatientData: any = { ...eachRow, ...eachRow.contact }
                customPatientData.dob = moment(new Date(eachRow.dob)).format("MM/DD/YYYY");
                patientInfo.push(customPatientData)
            }
            yield put({ type: DataEntryActionConstants.GET_PATIENT_SEARCH_DETAILS, data: patientInfo })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.GET_PATIENT_SEARCH_DETAILS_FAILURE })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getTransactionDocumentsSaga(action: any) {
    try {
        const response = yield callAPI(getTransactionDocumentsAPI, action)
        if (isSuccessStatusCode(response.status) && Array.isArray(response.data)) {
            yield put({ type: DataEntryActionConstants.getTransactionDocumentsSuccess, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.getTransactionDocumentsFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getTransactionDocumentsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getRejectOptionsSaga(action: any) {
    try {
        const response = yield callAPI(getRejectOptionsAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getRejectOptionsSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })

    }

}

export function* getContactRecordsDetails(action: any) {
    try {
        yield put({ type: DataEntryActionConstants.getContactSeacrhDetailsReset, data: [] })
        const response = yield callAPI(getContactDetailsAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getContactSeacrhDetailsSuccess, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.getContactSearchDetailsFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* patchPatientNoteSaga(action: any) {
    try {
        yield callAPI(patchPatientsNotesAPI, action);
        let response = yield callAPI(get, Api.getTransactionPatientAttributes + action.data.patientid + "?userID=" + global.userID + "&transactionid=" + action.data.transactionId)
        yield put({ type: DataEntryActionConstants.GET_TRANSACTIONS_PATIENT_ATTRIBUTES, data: response.data })
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* patchRequestorNoteSaga(action: any) {
    try {
        yield callAPI(patchRequestorNotesAPI, action)
        const requestorDetails = yield callAPI(getRequestorDetailsAPI, {
            requestorId: action.data.requestorid,
            requestorContactId: action.data.contactId
        })
        yield put({ type: DataEntryActionConstants.getRequestorDetailsSuccess, data: requestorDetails.data })

    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* patchSendToRequestorContactSaga(action: any) {
    try {
        const response = yield callAPI(patchSendToRequestorContact, action);
        if (isSuccessStatusCode(response.status)) {
            // requestor verification notification for email
            if (response.data.notificationFlag && response.data.notificationFlag.isVerificationSent && action.requestType != '31') {
                yield put({ type: DataEntryActionConstants.requestorVerificationEmailSent })
            }

            // Update release method if returned in response
            if (response.data.releaseMode != null) {
                yield put({
                    type: DataEntryActionConstants.setReleaseMethod,
                    data: response.data.releaseMode
                });
            }
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* uploadMultipleDocumentsSaga(action: UploadDocumentAction) {
    try {
        const organizationId = parseInt(action.data.transactionId.split("-")[0]);
        const requestBufferId = parseInt(action.data.transactionId.split("-")[1]);
        const response = yield callAPI(uploadDocumentAPI, action);
        if (isSuccessStatusCode(response.status)) {
            if (response.data.verified) {
                yield put({
                    type: DataEntryActionConstants.uploadDocumentSuccess, data: {
                        filename: action.data.fileName,
                        fileID: action.data.fileID,
                        error: null,
                        arePageizesValid: response.data.arePagesLetterSize,
                        invalidPagesNumbers: response.data.invalidPagesNumbers
                    },
                    timestamp: new Date()
                })
                yield put(push("/data"))
            } else {
                throw new Error("Verification failed. Please manually refresh.")
            }
        }
        // Spec #34100 / F1b-rois (AC1/AC2/AC3): auto-extract on request-document attach. The
        // recordType gate + reset-then-POST live in the extracted autoExtractOnRequestUpload
        // generator so the trigger is unit-testable without this suite's node:stream-tainted chain.
        // Invoked via call() (not yield*) so it runs as a sub-saga without needing downlevelIteration.
        // Bug fix (direct user report): this upload saga is shared by Classic and Quick Entry, but
        // the auto-trigger must only fire in Quick Entry - Classic (incl. the old-Intake "Extract"
        // button mode) must stay manual-only.
        //
        // AB#38014 fix: quickEntryActive is now read LIVE via select(), right before the gate
        // check, instead of trusting action.data.quickEntryActive (DataEntryDetails.
        // isQuickEntryEligible() snapshotted at upload-click time in DataEntryDetailsBody.
        // uploadFiles). The upload itself is awaited above, so on a brand-new transaction
        // facilityConfiguration/transactionDetails can resolve WHILE the upload is in flight -
        // a click-time snapshot can be stale by the time this gate actually runs, silently and
        // permanently skipping the trigger. isQuickEntryEligibleFromInputs is the same function
        // DataEntryDetails.isQuickEntryEligible() delegates to, so this is a live re-check with
        // the identical eligibility rule, not a second, drifting implementation of it.
        //
        // The live re-read is only valid while we are still ON the transaction this upload
        // belongs to: transactionStatusId/classicModeOverride are per-transaction, so if the
        // specialist navigated away mid-upload, live state describes the WRONG transaction.
        // In that case fall back to the click-time snapshot, which was correct for this
        // upload's own transaction.
        const eligibility = yield select((state: any) => ({
            isSameTransaction: state.landingPageState.transactionId === action.data.transactionId,
            quickEntryActiveNow: isQuickEntryEligibleFromInputs({
                intakeIntelligenceFlagEnabled: Boolean(state.loginState.featureFlags?.IntakeIntelligence),
                facilityIntakeIntelligenceEnabled: Boolean(state.dataEntryState.facilityConfiguration?.intakeIntelligenceEnabled),
                quickEntryFlagEnabled: Boolean(state.loginState.featureFlags?.QuickEntry),
                classicModeOverride: Boolean(state.dataEntryState.classicModeOverride),
                requestContext: state.landingPageState.requestContext,
                transactionStatusId: state.dataEntryState.transactionDetails?.transactionStatus?.id,
            }),
        }));
        const quickEntryActive = eligibility.isSameTransaction
            ? eligibility.quickEntryActiveNow
            : action.data.quickEntryActive;

        // The watcher is takeLatest, so a newer attach has already cancelled this task before it
        // could reach here - only the newest upload's trigger ever runs. That is the wanted
        // semantics for a single-file REQ slot, and it needs no sequence bookkeeping of its own.
        yield call(autoExtractOnRequestUpload, {
            recordType: action.data.recordType,
            organizationId,
            requestBufferId,
            quickEntryActive,
        });
    } catch (err) {
        yield put({
            type: DataEntryActionConstants.uploadDocumentFailure, data: {
                filename: action.data.fileName,
                fileID: action.data.fileID,
                error: (err as any).message
            },
            timestamp: new Date()
        })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        yield put({ type: DataEntryActionConstants.uploadDocumentInitial })
    } finally {
        // AB#38014: refresh the documents list here, on EVERY outcome, so the grid can never
        // silently disagree with the server about what is attached.
        //
        // The pre-existing refresh is a component effect (DataEntryDetailsBody, keyed on
        // uploadDocumentSuccess.fileID and gated on every tracked file reaching exactly
        // progress 100). It is left in place - it also clears the progress bars - but it has
        // several silent ways to never run: progress that never lands exactly on 100 (its deps
        // mean it never re-runs to catch up), a remount clearing the local progress map, and
        // the single shared uploadDocumentSuccess/Failure redux slot, where a sibling file's
        // failure nulls a success before the effect can consume it.
        //
        // A FAILED upload is refreshed deliberately, not incidentally: the document can be
        // committed server-side while the client sees an error (an exception thrown after the
        // row is written turns a stored document into a 400), which is exactly the "phantom
        // document" state where the viewer shows a file the grid does not know about.
        //
        // Only the refresh belongs here - NOT the auto-extract trigger. finally also runs when
        // the upload genuinely failed, and extraction must never fire for a document that was
        // never stored.
        //
        // Guarded on still being ON this upload's transaction. Nothing cancels an upload saga
        // on navigation, and documentsList is a single un-keyed slot: an upload finishing after
        // the specialist moved on would cancel the new transaction's own in-flight documents GET
        // (that watcher is takeLatest) and write the OLD transaction's documents into the slot -
        // after which the body auto-selects one and renders the old transaction's document in
        // the new transaction's viewer. The pre-existing refresh effect reads the CURRENT
        // transaction, so it never had this failure mode; this one must not introduce it.
        const currentTransactionId = yield select((state: any) => state.landingPageState.transactionId);
        if (currentTransactionId === action.data.transactionId) {
            yield put(getTransactionDocuments(action.data.transactionId));
        }
    }
}

/**
 * @deprecated not used
 * @param action
 */
export function* uploadDocumentSaga(action: any) {
    try {
        const response = yield callAPI(uploadDocumentAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: DataEntryActionConstants.uploadDocumentSuccess, data: {
                    filename: action.data.fileName,
                    fileID: action.data.fileID,
                    error: null,
                    arePageizesValid: response.data.arePagesLetterSize,
                    invalidPagesNumbers: response.data.invalidPagesNumbers
                },
                timestamp: new Date()
            })
            yield put(push("/data"))
        }
    } catch (err) {
        yield put({
            type: DataEntryActionConstants.uploadDocumentFailure, data: {
                filename: action.data.fileName,
                fileID: action.data.fileID,
                error: (err as any).message
            },
            timestamp: new Date()
        })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        yield put({ type: DataEntryActionConstants.uploadDocumentInitial })
    }
}

export function* postCancellationReasonsSaga(action: any) {
    try {
        const response = yield callAPI(postCancellationReasonsAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.postCancellationReasonsSuccess })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* postQATransactionIssueSaga(action: any) {
    try {
        const response = yield callAPI(postQATransactionIssueAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.postQATransactionIssueSuccess })
            yield put(getQAIssuesActionCreator(action.transactionID));
            yield put(getQAPDIssuesActionCreator(action.transactionID));
        } else {
            yield put({ type: DataEntryActionConstants.postQATransactionIssueFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* resolveQATransactionIssueSaga(action: any) {
    try {
        const response = yield callAPI(resolveIssueAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield (put({ type: DataEntryActionConstants.resolveQATransactionIssueSuccess }));
            yield put(getQAIssuesActionCreator(action.transactionId));
            yield put(getQAPDIssuesActionCreator(action.transactionId));
        } else {
            yield (put({ type: DataEntryActionConstants.resolveQATransactionIssueFailure }));
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* removeQATransactionIssueSaga(action: any) {
    try {
        const response = yield callAPI(removeIssueAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield (put({ type: DataEntryActionConstants.removeQATransactionIssueSuccess }));
            yield put(getQAIssuesActionCreator(action.transactionId));
            yield put(getQAPDIssuesActionCreator(action.transactionId));
        } else {
            yield (put({ type: DataEntryActionConstants.removeQATransactionIssueFailure }));
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* disputeIssueSaga(action: any) {
    try {
        const respone = yield callAPI(disputeIssueAPI, action);
        if (isSuccessStatusCode(respone.status)) {
            yield (put({ type: DataEntryActionConstants.disputeIssueSuccess }));
            yield put(getQAIssuesActionCreator(action.transactionId));
        } else {
            yield put({ type: DataEntryActionConstants.disputeIssueFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.disputeIssueFailure, data: (err as any).response });
    }
}

export function* upholdIssueSaga(action: any) {
    try {
        const respone = yield callAPI(upholdIssueAPI, action);
        if (isSuccessStatusCode(respone.status)) {
            yield (put({ type: DataEntryActionConstants.upholdIssueSuccess }));
            yield put(getQAIssuesActionCreator(action.transactionId));
        } else {
            yield put({ type: DataEntryActionConstants.upholdIssueFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.upholdIssueFailure, data: (err as any).response });
    }
}

export function* getTransactionNoteTypesSaga(action: any) {
    try {
        const response = yield callAPI(getTransactionNoteTypesAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getTransactionNoteTypesSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }

}

export function* updateTransactionNotesSaga(action: any) {
    try {
        yield callAPI(updateTransactionNotesAPI, action)
        yield callAPI(getTransactionNotes, { data: action.data.transactionId })
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* updateAdditionalChargesSaga(action: any) {
    try {
        yield callAPI(updateAdditionalChargesAPI, action)
        action.onSuccess?.();
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        action.onError?.();
    }
}

export function* rejectionContactOverrideSaga(action: any) {
    try {
        yield callAPI(rejectionContactOverrideAPI, action)
        yield put(goBack())
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* updateDocumentSaga(action: any) {
    try {
        yield callAPI(updateDocumentAPI, action)
        yield put(getTransactionDocuments(action.data.transactionId))
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* batchUpdateDocumentsSaga(action: { data: DocumentUpdateRequests }) {
    try {
        yield callAPI(batchUpdateDocumentsAPI, action.data);
        yield put(getTransactionDocuments(action.data.transactionId));
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getDocumentSourcesSaga(action: any) {
    try {
        const response = yield callAPI(getDocumentSourcesAPI, action)
        yield put({ type: DataEntryActionConstants.getDocumentSourcesSuccess, data: response.data })
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getRejectionLetterSaga(action: any) {
    try {
        const response = yield callAPI(getRejectionLetterDataAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getRejectionLetterDataAPISuccess, data: response.data })
            yield put({ type: DataEntryActionConstants.getRejectionLetterDataAPIInitial })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getPreviousTransactionSaga(action: any) {
    try {
        const response = yield callAPI(getPreviousTransactionAPI, action);
        if (isSuccessStatusCode(response.status) && response.data.id) {
            if (response.data.isReadOnly) {
                yield put({ type: LandingPageActionConstants.SHOW_READONLY_TRANSACTION_REQUEST, data: response.data.id })
                yield put(push("/home"))
            } else {
                yield put({ type: DataEntryActionConstants.getPreviousTransactionAPISuccess, data: response.data })
                // AB#39020: the action only carries a transaction id, so the returned id is the
                // only facility source available - and it's the correct one (the transaction just opened).
                yield call(refreshSelectedFacilityCountsSaga, parseInt(String(response.data.id).split("-")[0], 10))
            }
        }
        else if (!response.data.id) {
            yield put({ type: LandingPageActionConstants.HEADER_ASSIGN_TRANSACTION_INFORMATION, data: 'No previous transaction available.' })
            yield put(push("/home"))
        }
        else {
            yield put({ type: DataEntryActionConstants.getPreviousTransactionAPIFailure, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* updateBillingFieldsSaga(action: { data: any, updateData?: boolean, onSuccess?: () => void, onError?: () => void }) {
    try {
        const response = yield callAPI(updateBillingPaneFieldsAPI, action);
        if (action.updateData) {
            yield put(getTransactionAttributesActionCreator(action.data.transactionId))
        }

        if (isSuccessStatusCode(response.status)) {
            if (action.data.clinicdepartmentid) {
                yield put({ type: DataEntryActionConstants.updateClinicIDResponse, data: action.data.clinicdepartmentid })
            }
            if (action.data.sendToRequestorid) {
                const txid = action.data.transactionId.split("-");
                yield put(getFeeScheduleData(txid[0], action.data.transactionId, true));
            }
            action.onSuccess?.();
        } else {
            action.onError?.();
        }
    } catch (err) {
        // AB#39575 addendum: this save's failures (e.g. an invalid fee schedule, now returned
        // as a structured ValidationProblem() rather than the legacy {code,message} envelope)
        // otherwise only reach the specialist as APIErrorPopUp's unconditional "Service is
        // temporarily unavailable" banner, with no detail line for this shape. Same extractor
        // AB#35119 already uses at the contact-save/requestor-create call sites.
        const validationMessage = serverValidationMessage(err);
        if (validationMessage) {
            toast.error(validationMessage);
        }
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        action.onError?.();
    }
}

export function* getPHICodesSaga(action: any) {
    try {
        const response = yield callAPI(getPHICodesAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getPHICodesSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getRetrieveProtocolsSaga(action: any) {
    try {
        const response = yield callAPI(retrieveProtocolAPI, action);
        if (isSuccessStatusCode(response.status) && Array.isArray(response.data)) {
            yield put({ type: DataEntryActionConstants.getRetrieveProtocolSuccess, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.getRetrieveProtocolFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* createPatientRecordSaga(action: any) {
    try {
        const response = yield callAPI(createPatientRecordAPI, action)
        if (isSuccessStatusCode(response.status)) {
            const requestObject = {
                transactionId: action.data.transactionId,
                userID: global.userID,
                patientDataid: response.data.id,
            }
            ///yield put({ type: DataEntryActionConstants.updateBillingPaneFields, data: requestObject, updateData: true })
            yield put(getTransactionAttributesActionCreator(action.data.transactionId))
            yield put({ type: DataEntryActionConstants.createPatientRecordSuccess, data: response.data })
            action.onSuccess && action.onSuccess()
        } else {
            // Non-2xx without a thrown error: signal failure so awaiting callers
            // (Quick Entry's Confirm-All persist gate) don't hang.
            action.onError && action.onError()
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        action.onError && action.onError()
    }
}

export function* postRejectionActionSaga(action: { data: Rejection }) {
    try {
        const response = yield callAPI(postRejectionActionAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.POST_REJECTION_ACTION, data: response.data })
            yield callAPI(generateNextTransactionId, { data: { facilityId: action.data.facilityId, context: action.data.requestContext } })
        } else {
            yield put({ type: DataEntryActionConstants.POST_REJECTION_ACTION_FAILURE })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        yield put({ type: DataEntryActionConstants.POST_REJECTION_ACTION_FAILURE })
    }
}

export function* getUserGroupsSaga(action: any) {
    try {
        const response = yield callAPI(getUserGroupsAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getUserGroupsSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* getDisclosureReasonSaga(action: any) {
    try {
        const response = yield callAPI(getDisclosureReasonAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.GET_DISCLOSURE_REASON, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })

    }

}

export function* updateDisclosureInformationSaga(action: any) {
    try {
        const response = yield callAPI(updateDisclosureInformationAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.UPDATE_DISCLOSURE_INFORMATION, data: response.data })
            // Spec #35135: optional, added for Quick Entry's awaited Confirm-All gate.
            // Classic passes neither callback, so its behavior is unchanged.
            action.onSuccess?.();
        } else {
            action.onError?.();
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        action.onError?.();
    }
}

export function* getUserTasksSaga(action: any) {
    try {
        const response = yield callAPI(getUserTasksAPI, action)
        if (isSuccessStatusCode(response.status) && Array.isArray(response.data)) {
            let normalizedUserTaskComments = {}
            let taskIdsList: any[] = []
            const responseAPI = yield all(response.data.map(item => {
                taskIdsList.push(item.id)
                return call(getUserTaskCommentsAPI, { data: item.id })
            }))
            taskIdsList.map((id, index) => {
                const sortedComments = responseAPI ? sortDateObject(responseAPI[index].data, "createdDate").reverse() : []
                normalizedUserTaskComments = {
                    ...normalizedUserTaskComments,
                    [id]: sortedComments
                }
                return null
            })
            let totalTasks = getSortedTasks(response.data)
            yield put({ type: DataEntryActionConstants.getUserTasksSuccess, data: totalTasks, comments: normalizedUserTaskComments })
        } else {
            yield put({ type: DataEntryActionConstants.getUserTasksFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }


}

export function* deleteTransactionTaskSaga(action: any) {
    try {
        const response = yield callAPI(deleteTransactionTaskAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.DELETE_TRANSACTION_TASK, data: action.data.usertaskId })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).message })
    }
}

export function* completeTransactionSaga(action: any) {
    try {
        const response = yield callAPI(completeTransactionAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.COMPLETE_TRANSACTION_REQUEST, data: response.data.message })
            if (response.data.code === 0) {
                let win = window.open(response.data.message)
                setTimeout(() => { win ? win.close() : console.log() }, 9000)
            }
            // Spec #35135: optional, added so Quick Entry's Disclosure Accounting
            // completion can show its success card only once the finalize landed.
            // Every pre-existing caller passes neither callback.
            action.onSuccess?.();
        } else {
            action.onError?.();
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).message })
        action.onError?.();
    }
}

export function* returnToQueueSaga(action: any) {
    try {
        const response = yield callAPI(returnToQueueAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.COMPLETE_TRANSACTION_REQUEST, data: response.data.message })
            if (response.data.code === 0) {
                let win = window.open(response.data.message)
                setTimeout(() => { win ? win.close() : console.log() }, 9000)
            }
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).message });
    }
}

export function* patchDetailsCompleteSaga(action: any) {
    try {
        yield callAPI(patchDetailsCompleteAPI, action)
        // AB#31605 (round-1 review CRITICAL-4): optional, added so Quick Entry's type-66
        // finalize can run AFTER this audit write instead of racing it for locks on the
        // same transaction row. Classic passes neither callback, so its behavior is
        // unchanged.
        action.onSuccess?.();
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        action.onError?.();
    }
}

export function* patchRequestorCompleteSaga(action: any) {
    try {
        yield callAPI(patchRequestorCompleteAPI, action)

        const billToRequestorDetails = yield callAPI(getRequestorBillingDetailsByTxAPI, action.data)
        yield put(getTransactionAttributesActionCreator(action.data.transactionId))
        yield put({ type: DataEntryActionConstants.getRequestorBillingDetailsSuccess, data: billToRequestorDetails.data })

    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* patchBillingCompleteSaga(action: any) {
    try {
        const response = yield callAPI(patchBillingCompleteAPI, action)
        if (isSuccessStatusCode(response.status)) {
            action.onSuccess?.();
        } else {
            action.onError?.();
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        action.onError?.();
    }
}

export function* patchPatientDetailsSaga(action: any) {
    try {
        yield callAPI(patchPatientDetailsAPI, action)
        yield put({ type: DataEntryActionConstants.updatePatientDetails, data: action.data })
    } catch (err) {
        yield put({ type: DataEntryActionConstants.patchPatientDetails })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getAuditTypesSaga() {
    try {
        const response = yield callAPI(getAuditTypesAPI)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getAuditTypesSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getAuditTypesFailure, data: (err as any).response })
    }
}

export function* getOBOsSaga() {
    try {
        const response = yield callAPI(getOBOsAPI)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getOBOsSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getOBOsFailure, data: (err as any).response })
    }
}

export function* displayLateValidation(results: any) {
    let resultsText = results.data;

    yield put({ type: DataEntryActionConstants.getValidateFailure, data: false })
    yield put({
        type: DataEntryActionConstants.POPUP_ERROR_STATE, data: {
            popupErrorHeader: "Validation Errors Occurred",
            popupErrorBody: "The following errors occurred when trying to complete the transaction request:",
            popupErrorMessages: resultsText

        }
    })
}

export function* getValidateSaga(action: any) {
    try {
        const response = yield callAPI(getValidateAPI, action)
        if (isSuccessStatusCode(response.status)) {
            if (response.data.length == 0) {
                yield put({ type: DataEntryActionConstants.getValidateSuccess, data: true })
            } else {
                yield put({ type: DataEntryActionConstants.getValidateFailure, data: false })
                yield put({
                    type: DataEntryActionConstants.POPUP_ERROR_STATE, data: {
                        popupErrorHeader: "Validation Errors Occurred",
                        popupErrorBody: "The following errors occurred when trying to complete the transaction request:",
                        popupErrorMessages: response.data.map(d => d.message),

                    }
                })
            }
        } else {
            yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: response.status })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getAuditTrailSaga(action: any) {
    try {
        const response = yield call(getAuditTrailAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getAuditTrailResponse, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getQAErrorsSaga() {
    try {
        const response = yield callAPI(getQAErrorsAPI)
        if (isSuccessStatusCode(response.status)) {
            if (response.data.length > 0) {
                yield put({ type: DataEntryActionConstants.GET_QA_ERRORS_RESULTS_SUCCESS, data: response.data })
            }
        } else {
            yield put({ type: DataEntryActionConstants.GET_QA_ERRORS_RESULTS_FAILURE, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getSensitivityTypesSaga() {
    try {
        const response = yield callAPI(getAISensitivityTypesAPI)
        if (isSuccessStatusCode(response.status)) {
            if (response.data.length > 0) {
                yield put({ type: DataEntryActionConstants.GET_SENSITIVITY_TYPES_RESULTS_SUCCESS, data: response.data })
            }
        } else {
            yield put({ type: DataEntryActionConstants.GET_SENSITIVITY_TYPES_RESULTS_FAILURE, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getQAIssuesSaga(action: any) {
    try {
        const response = yield callAPI(getQAIssuesAPI, action)
        if (isSuccessStatusCode(response.status) && Array.isArray(response.data)) {
            yield put({ type: DataEntryActionConstants.GET_QA_ISSUES_RESULTS_SUCCESS, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.GET_QA_ISSUES_RESULTS_FAILURE, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getQAPDIssuesSaga(action: any) {
    try {
        const response = yield callAPI(getQAPDIssuesAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.GET_QA_PD_ISSUES_RESULTS_SUCCESS, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.GET_QA_PD_ISSUES_RESULTS_FAILURE, data: response.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getDuplicatesSaga(action: any) {
    try {
        const response = yield callAPI(getDuplicatesAPI, action)
        if (isSuccessStatusCode(response.status)) {
            if (response.data.length > 0) {
                yield put({ type: DataEntryActionConstants.SHOW_DUPLICATE_TRANSACTIONS, data: { duplicates: response.data } })
            }
        } else {
            yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: response.status })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getTransactionDocumentsToCopySaga(action: any) {
    try {
        const response = yield callAPI(getTransactionDocumentsOnFileAPI, action)
        if (isSuccessStatusCode(response.status) && Array.isArray(response.data)) {
            yield put({ type: DataEntryActionConstants.getTransactionDocumentsToCopySuccess, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.getTransactionDocumentsFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getTransactionDocumentsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}
export function* updateTransactionOnFileSaga(action: any) {
    try {
        const response = yield callAPI(patchTransactionOnFileAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put(getTransactionDocuments(action.data.transactionId))
            yield put({ type: DataEntryActionConstants.patchTransactionOnFileSuccess })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.patchTransactionOnFileFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* postWPSTokenSaga(action: any) {
    try {
        const response = yield callAPI(postWebPrintScanAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.postWPSResponse, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: response.status })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* readBarCodeDDsSaga(action: any) {
    try {
        const response = yield callAPI(readDocumentDDSBarcodeAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.readBarCodeDDSSuccess, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.readBarCodeDDSFailure })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.readBarCodeDDSFailure })
    }
}

export function* getFacilitiesAdditionalFieldsSaga(action: any) {
    try {
        const response = yield callAPI(getFacilitiesAdditionalFieldsAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getFacilityAdditionalFieldsSuccess, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.getFacilityAdditionalFieldsSuccess })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getFacilityAdditionalFieldsSuccess })
    }
}


export function* getWaitAndHoldReasonsSaga(action: any) {
    try {
        const result = yield callAPI(getWaitAndHoldReasonsAPI, action)
        if (isSuccessStatusCode(result.status)) {
            yield put({ type: DataEntryActionConstants.getWaitAndHoldReasonsSuccess, data: result.data })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getWaitAndHoldReasonsFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    } finally {
        yield put({ type: DataEntryActionConstants.initialTxCountIncrement })
    }
}
export function* postWaitAndHoldReasonsSaga(action: any) {
    try {
        const response = yield callAPI(postWaitAndHoldReasonsAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.postWaitAndHoldReasonsSuccess })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}
export function* patchTransactionContinueSaga(action: any) {
    try {
        const response = yield callAPI(patchTransactionContinueAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.patchTransactionContinueSuccess })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* putAuditDigitalFaxValidationSaga(action: any) {
    try {
        const response = yield callAPI(putAuditDigitalFaxValidationAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.putDigitalFaxValidationSuccess })
            action.onSuccess?.();
        } else {
            action.onError?.();
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        action.onError?.();
    }
}

export function* putAuditTransactionSensitiveInfoSaga(action: any) {
    try {
        const response = yield callAPI(putAuditTransactionSensitiveInfoAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.putAuditTransactionSensitiveInfoSuccess })
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getStatusIndicatorSaga(action: any) {
    try {
        const response = yield call(getStatusIndicatorAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getStatusIndicatorResponse, data: response.data })
        } else {
            yield put({ type: DataEntryActionConstants.getStatusIndicatorResponse })
        }
    } catch (err) {
        yield put({
            type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response
        })
    }
}

export function* userViewedDocumentSaga(action: any) {
    try {
        const response = yield call(putUserViewDocumentAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.userViewedDocumentSucess })
        } else {
            yield put({ type: DataEntryActionConstants.userViewedDocumentFailure })
        }

    } catch (err) {
        yield put({ type: DataEntryActionConstants.userViewedDocumentFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getAuditUsersSaga(action: any) {
    try {
        const response = yield call(getAuditUsersAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.getAuditUsersSuccess, data: response.data });
        } else {
            yield put({ type: DataEntryActionConstants.getAuditUsersFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getAuditUsersFailure });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* getAIFeedbackSaga() {
    try {
        const response = yield call(getAIFeedbackAPI);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.GET_AI_FEEDBACK_SUCCESS, data: response.data });
        } else {
            yield put({ type: DataEntryActionConstants.GET_AI_FEEDBACK_FAILURE });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.GET_AI_FEEDBACK_FAILURE });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* submitAIFeedbackSaga(action: any) {
    try {
        const response = yield call(submitAIFeedbackAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_SUCCESS });
        } else {
            yield put({ type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_FAILURE });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_FAILURE });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* deleteAIFeedbackSaga(action: any) {
    try {
        const response = yield call(deleteAIFeedbackAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.DELETE_AI_FEEDBACK_SUCCESS });
        } else {
            yield put({ type: DataEntryActionConstants.DELETE_AI_FEEDBACK_FAILURE });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.DELETE_AI_FEEDBACK_FAILURE });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* submitAIFeedbackBulkSaga(action: any) {
    try {
        const response = yield call(submitAIFeedbackBulkAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_BULK_SUCCESS });
        } else {
            yield put({ type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_BULK_FAILURE });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.SUBMIT_AI_FEEDBACK_BULK_FAILURE });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* undoAIFeedbackBulkSaga(action: any) {
    try {
        const response = yield call(undoAIFeedbackBulkAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.UNDO_AI_FEEDBACK_BULK_SUCCESS });
        } else {
            yield put({ type: DataEntryActionConstants.UNDO_AI_FEEDBACK_BULK_FAILURE });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.UNDO_AI_FEEDBACK_BULK_FAILURE });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* createAIReviewEntitySaga(action: { reviewEntity: qaReviewEntityProps }) {
    try {
        const response = yield callAPI(createAIReviewEntityAPI, action);
        yield put({ type: DataEntryActionConstants.createAIReviewEntitySuccess });
        yield put({
            type: DataEntryActionConstants.GET_REVIEW_ENTITIES,
            transactionId: action.reviewEntity.organizationID + "-" + action.reviewEntity.requestBufferID
        });
    } catch (err) {
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
        yield put({ type: DataEntryActionConstants.createAIReviewEntityFailure });
    }
}

export function* uploadReplaceDocumentSaga(action: any) {
    try {
        const response = yield callAPI(action.data.blob ? uploadUpdateBlobDocumentAPI : uploadUpdateDocumentAPI, action)
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: DataEntryActionConstants.updateReplaceDocumentSuccess })
            yield put({ type: DataEntryActionConstants.uploadDocumentSuccess })
        } else {
            yield put({ type: DataEntryActionConstants.updateReplaceDocumentFailure });
            yield put({ type: DataEntryActionConstants.uploadDocumentFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.updateReplaceDocumentFailure })
        yield put({ type: DataEntryActionConstants.uploadDocumentFailure })
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response })
    }
}

export function* getCertificationTypesSaga() {
    try {
        const response = yield (callAPI(getCertificationTypesAPI));
        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: DataEntryActionConstants.getCertificationTypesSuccess,
                data: response.data,
            });
        } else {
            yield put({ type: DataEntryActionConstants.getCertificationTypesFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getCertificationTypesFailure });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* setCertificationTemplateSaga(action: any) {
    try {
        const response = yield (callAPI(setCertificationTemplateAPI, action));
        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: DataEntryActionConstants.setCertificationTemplateSuccess,
                data: response.data,
            });
            action.onSuccess?.();
        } else {
            yield put({ type: DataEntryActionConstants.setCertificationTemplateFailure });
            action.onError?.();
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.setCertificationTemplateFailure });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
        action.onError?.();
    }
}

export function* getCompleteStatusCheckSaga(action: any) {
    try {
        const response = yield (callAPI(getCompleteStatusCheckAPI, action));
        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: DataEntryActionConstants.getCompleteStatusCheckSuccess,
                data: response.data,
            });
        } else {
            yield put({ type: DataEntryActionConstants.getCompleteStatusCheckFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getCompleteStatusCheckFailure });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

export function* getFeeSchedulesCheckSaga(action: any) {
    try {
        const response = yield (callAPI(getFeeSchedulesCheckAPI, action));
        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: DataEntryActionConstants.getFeeSchedulesCheckSuccess,
                data: response.data,
            });
        } else {
            yield put({ type: DataEntryActionConstants.getFeeSchedulesCheckFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getFeeSchedulesCheckFailure });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

interface FacilityConfigurationSaga {
    type: string, data: number
}

export function* getFacilityConfigurationSaga(action: FacilityConfigurationSaga) {
    try {
        const response = yield(callAPI(getFacilityConfigurationAPI, action.data));
        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: DataEntryActionConstants.getFacilityConfigurationSuccess,
                data: response.data as FacilityConfiguration,
            });
        } else {
            yield put({ type: DataEntryActionConstants.getFacilityConfigurationFailure });
        }
    } catch (err) {
        yield put({ type: DataEntryActionConstants.getFacilityConfigurationFailure });
        yield put({ type: DataEntryActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}

// getIntakeIntelligenceSaga / requestIntakeIntelligenceSaga /
// setFeedbackForIntakeFieldSaga moved to IntakeDucks.ts (Spec #34098 / F1a,
// AC17, tidy-first #5) - imported above; services/sagas/index.js registers
// them from there directly. Re-exported below for any other existing import
// sites.
